import React__default, { createRef, createElement, Component, Children, cloneElement, Fragment } from 'react';
import * as ReactModal from 'react-modal';
import { setAppElement } from 'react-modal';
import { createPortal, findDOMNode } from 'react-dom';
import _ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-day-picker/lib/style.css';
import { DragSource, DropTarget } from 'react-dnd';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgComponent = function (props) {
  return React__default.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M14.83 16.42L24 25.59l9.17-9.17L36 19.25l-12 12-12-12z"
  }));
};

var mtrAccordion = "mtr-accordion";
var mtrAccordionTitle = "mtr-accordion__title";
var mtrAccordionTitleText = "mtr-accordion__title-text";
var mtrAccordionTitleIcon = "mtr-accordion__title-icon";
var mtrAccordionContentWrapper = "mtr-accordion__content-wrapper";
var mtrAccordionContent = "mtr-accordion__content";
var mtrAccordionOpen = "mtr-accordion--open";

/**
 * The component that contains the Accordion content
 */
var AccordionContent = /** @class */ (function (_super) {
    __extends(AccordionContent, _super);
    function AccordionContent(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = createRef();
        return _this;
    }
    AccordionContent.prototype.componentDidMount = function () {
        // Set the component height when it's first mounted
        var current = this.ref.current;
        if (current) {
            current.style.height = this.props.open
                ? current.scrollHeight + "px"
                : '0';
        }
    };
    AccordionContent.prototype.render = function () {
        // If the accordion is open, set its content height to the actual height of
        // the content
        var contentStyle = {};
        if (this.ref.current) {
            contentStyle.height = this.props.open
                ? this.ref.current.scrollHeight + "px"
                : '0';
        }
        var className = classnames(mtrAccordionContent, this.props.className);
        return (createElement("div", { ref: this.ref, style: contentStyle, className: mtrAccordionContentWrapper },
            createElement("div", { className: className, style: this.props.style }, this.props.children)));
    };
    return AccordionContent;
}(Component));
/**
 * An expandable container
 */
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Accordion.prototype.render = function () {
        var _this = this;
        var _a;
        var className = classnames(mtrAccordion, (_a = {},
            _a[mtrAccordionOpen] = this.props.open,
            _a), this.props.className);
        var children = Children.map(this.props.children, function (child) {
            var childElement = child;
            var childType = childElement.type;
            if (childType.name === AccordionTitle.name) {
                var childProps = childElement.props;
                return cloneElement(childElement, {
                    onClick: childProps.onClick || _this.props.onClick
                });
            }
            if (childType.name === AccordionContent.name) {
                return cloneElement(childElement, {
                    open: _this.props.open
                });
            }
            return child;
        });
        return (createElement("div", { className: className, style: this.props.style }, children));
    };
    Accordion.Title = AccordionTitle;
    Accordion.Content = AccordionContent;
    return Accordion;
}(Component));
/**
 * Component used to render the Accordion title
 */
function AccordionTitle(props) {
    var className = classnames(mtrAccordionTitle, props.className);
    return (createElement("div", { className: className, style: props.style, onClick: props.onClick },
        createElement("div", { className: mtrAccordionTitleText }, props.children),
        createElement("div", { className: mtrAccordionTitleIcon },
            createElement(SvgComponent, null))));
}

var mtrAvatar = "mtr-avatar";

function Avatar(props) {
    var name = props.name, backgroundColor = props.backgroundColor, color = props.color;
    var names = name.split(/\s+/);
    var initials = names.map(function (n) { return n[0].toUpperCase(); });
    var className = classnames(mtrAvatar, props.className);
    var divProps = { className: className };
    if (color || backgroundColor) {
        divProps.style = {};
        if (color) {
            divProps.style.color = color;
        }
        if (backgroundColor) {
            divProps.style.backgroundColor = backgroundColor;
        }
    }
    return createElement("div", __assign({}, divProps), initials);
}

var mtrBadge = "mtr-badge";
var mtrBadgeClickable = "mtr-badge__clickable";
var mtrBadgeClose = "mtr-badge--close";
var mtrBadgeSm = "mtr-badge--sm";
var mtrBadgeMd = "mtr-badge--md";
var mtrBadgePrimary = "mtr-badge--primary";
var mtrBadgeDanger = "mtr-badge--danger";
var mtrBadgeSuccess = "mtr-badge--success";
var mtrBadgeWarning = "mtr-badge--warning";
var mtrBadgeNeutral = "mtr-badge--neutral";

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgComponent$1 = function (props) {
  return React__default.createElement("svg", _extends$1({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M38 12.83L35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24z"
  }));
};

function Badge(props) {
    var className = props.className, closed = props.closed, content = props.content, onClick = props.onClick, onClose = props.onClose;
    var classes = classnames(mtrBadge, onClick && mtrBadgeClickable, getTypeClass(props), getSizeClass(props), className);
    var styleProps = getStyles(props);
    return closed ? null : (createElement("div", { className: classes, style: styleProps.rootStyles, onClick: onClick },
        content,
        onClose ? (createElement("div", { className: mtrBadgeClose, onClick: onClose, style: styleProps.iconStyles },
            createElement(SvgComponent$1, null))) : (undefined)));
}
function getSizeClass(props) {
    switch (props.size) {
        case 'sm':
            return mtrBadgeSm;
        case 'md':
            return mtrBadgeMd;
        default:
            return;
    }
}
function getStyles(props) {
    var badgeStyles = {
        rootStyles: {},
        iconStyles: {}
    };
    var backgroundColor = props.backgroundColor, color = props.color;
    if (color) {
        badgeStyles.rootStyles.color = color;
        badgeStyles.iconStyles.fill = color;
    }
    if (backgroundColor) {
        badgeStyles.rootStyles.backgroundColor = backgroundColor;
    }
    return badgeStyles;
}
function getTypeClass(props) {
    switch (props.type) {
        case 'primary':
            return mtrBadgePrimary;
        case 'danger':
            return mtrBadgeDanger;
        case 'success':
            return mtrBadgeSuccess;
        case 'warning':
            return mtrBadgeWarning;
        case 'neutral':
            return mtrBadgeNeutral;
        default:
            return;
    }
}

var mtrBanner = "mtr-banner";
var mtrBannerSuccess = "mtr-banner--success";
var mtrBannerBody = "mtr-banner__body";
var mtrBannerWarning = "mtr-banner--warning";
var mtrBannerDanger = "mtr-banner--danger";
var mtrBannerInfo = "mtr-banner--info";
var mtrBannerMedia = "mtr-banner__media";
var mtrBannerTitle = "mtr-banner__title";

var mtrHeading = "mtr-heading";
var mtrHeadingXxs = "mtr-heading--xxs";
var mtrHeadingXs = "mtr-heading--xs";
var mtrHeadingSm = "mtr-heading--sm";
var mtrHeadingMd = "mtr-heading--md";
var mtrHeadingLg = "mtr-heading--lg";
var mtrHeadingXl = "mtr-heading--xl";
var mtrHeadingXxl = "mtr-heading--xxl";
var mtrHeadingInverted = "mtr-heading--inverted";
var mtrHeadingUnderlined = "mtr-heading--underlined";
var mtrHeadingBold = "mtr-heading--bold";

/**
 * Banner is a component used to call out informational or warning messages.
 */
function Banner(props) {
    var title = props.title, children = props.children, media = props.media, _a = props.type, type = _a === void 0 ? 'info' : _a;
    var className = classnames(mtrBanner, getTypeClass$1(type), props.className);
    return (createElement("div", { className: className },
        createElement("div", { className: mtrBannerMedia },
            createElement("h6", { className: mtrHeadingSm }, media)),
        createElement("div", { className: mtrBannerBody },
            createElement("h3", { className: mtrBannerTitle }, title),
            createElement("div", { className: mtrBannerBody }, children))));
}
function getTypeClass$1(type) {
    switch (type) {
        case 'info':
            return mtrBannerInfo;
        case 'warning':
            return mtrBannerWarning;
        case 'danger':
            return mtrBannerDanger;
        case 'success':
            return mtrBannerSuccess;
        default:
            return;
    }
}

var mtrBtn = "mtr-btn";
var mtrBtnShadow = "mtr-btn--shadow";
var mtrBtnBlock = "mtr-btn--block";
var mtrBtnLoading = "mtr-btn--loading";
var mtrBtnIcon = "mtr-btn-icon";
var mtrBtnIconOnly = "mtr-btn--icon-only";
var mtrBtnXs = "mtr-btn--xs";
var mtrBtnSm = "mtr-btn--sm";
var mtrBtnMd = "mtr-btn--md";
var mtrBtnLg = "mtr-btn--lg";
var mtrBtnXl = "mtr-btn--xl";
var mtrBtnPrimary = "mtr-btn--primary";
var mtrBtnOutline = "mtr-btn--outline";
var mtrBtnSecondary = "mtr-btn--secondary";
var mtrBtnDanger = "mtr-btn--danger";
var mtrBtnSuccess = "mtr-btn--success";
var mtrBtnTransparent = "mtr-btn--transparent";
var mtrBtnTransparentInverted = "mtr-btn--transparent-inverted";
var mtrBtnDisabled = "mtr-btn--disabled";
var mtrBtnLink = "mtr-btn--link";
var mtrBtnGroup = "mtr-btn__group";

/**
 * A Button lets a user take an action or indicate something.
 */
function Button(props) {
    var label = props.label, icon = props.icon, disabled = props.disabled, name = props.name, href = props.href, onClick = props.onClick, _a = props.type, type = _a === void 0 ? 'button' : _a;
    var styleProp = getStyles$1(props);
    var className = getClasses(props);
    var content = (createElement(Fragment, null,
        props.loading || !props.icon ? ('') : (createElement("span", { className: mtrBtnIcon }, icon)),
        props.loading ? '' : label));
    var renderedButton = href ? (createElement("a", { className: className, href: disabled ? undefined : href, style: styleProp }, content)) : (createElement("button", { className: className, disabled: disabled, onClick: onClick, name: name, type: type, style: styleProp }, content));
    return props.children ? (createElement("div", { className: mtrBtnGroup },
        renderedButton,
        props.children)) : (renderedButton);
}
function getClasses(props) {
    var _a, _b;
    var _c = props.buttonType, buttonType = _c === void 0 ? 'primary' : _c;
    return classnames(mtrBtn, getTypeClass$2(buttonType), (_a = {},
        _a[mtrBtnDisabled] = props.disabled,
        _a[mtrBtnOutline] = props.outline,
        _a[mtrBtnShadow] = props.shadow,
        _a[mtrBtnLoading] = props.loading,
        _a[mtrBtnBlock] = props.block,
        _a), getSizeClass$1(props.size), (_b = {},
        _b[mtrBtnIconOnly] = Boolean(props.icon && !props.label),
        _b), props.className);
}
function getTypeClass$2(style) {
    switch (style) {
        case 'primary':
            return mtrBtnPrimary;
        case 'secondary':
            return mtrBtnSecondary;
        case 'danger':
            return mtrBtnDanger;
        case 'success':
            return mtrBtnSuccess;
        case 'transparent':
            return mtrBtnTransparent;
        case 'transparent-inverted':
            return mtrBtnTransparentInverted;
        case 'link':
            return mtrBtnLink;
        default:
            return;
    }
}
function getSizeClass$1(size) {
    switch (size) {
        case 'xs':
            return mtrBtnXs;
        case 'sm':
            return mtrBtnSm;
        case 'md':
            return mtrBtnMd;
        case 'lg':
            return mtrBtnLg;
        case 'xl':
            return mtrBtnXl;
        default:
            return;
    }
}
function getStyles$1(props) {
    var backgroundColor = props.backgroundColor, color = props.color, disabled = props.disabled, style = props.style;
    if (!disabled && (color || backgroundColor || style)) {
        var styleProp = {};
        if (color) {
            styleProp.color = color;
            styleProp.fill = color;
        }
        if (backgroundColor) {
            styleProp.background = backgroundColor;
            styleProp.borderColor = backgroundColor;
        }
        if (style) {
            Object.assign(styleProp, style);
        }
        return styleProp;
    }
    return;
}

var mtrCheckbox = "mtr-checkbox";
var mtrCheckboxBackdrop = "mtr-checkbox__backdrop";

var subtext$1 = "subtext";
var subdued$1 = "subdued";
var mtrFormLabel = "mtr-form__label";
var mtrFormLabelInline = "mtr-form__label--inline";
var mtrFormLabelText = "mtr-form__label__text";
var mtrFormLabelTextAside = "mtr-form__label__text__aside";
var mtrFormControl = "mtr-form__control";
var mtrFormControlGroup = "mtr-form__control-group";
var mtrFormOptionsGroup = "mtr-form__options-group";
var mtrFormField = "mtr-form__field";
var mtrFormLabelHorizontal = "mtr-form__label__horizontal";
var mtrFormLabelCheckbox = "mtr-form__label__checkbox";
var mtrFormControlSm = "mtr-form__control--sm";
var mtrFormControlMd = "mtr-form__control--md";
var mtrFormControlLg = "mtr-form__control--lg";
var mtrFormControlDescriptor = "mtr-form__control-descriptor";
var mtrFormControlGroupInline = "mtr-form__control-group--inline";
var mtrFormControlDescriptorSm = "mtr-form__control-descriptor--sm";
var mtrFormControlDescriptorMd = "mtr-form__control-descriptor--md";
var mtrFormControlDescriptorLg = "mtr-form__control-descriptor--lg";
var mtrFormOptionsItem = "mtr-form__options-item";
var mtrFormOptionsGroupStacked = "mtr-form__options-group--stacked";
var mtrForm = "mtr-form";
var mtrFormControlInline = "mtr-form__control--inline";

function getSizeClass$2(size) {
    if (!size) {
        return;
    }
    switch (size) {
        case 'sm':
            return mtrFormControlSm;
        case 'md':
            return mtrFormControlMd;
        default:
            return mtrFormControlLg;
    }
}
function addSubtext(component, options) {
    if (options === void 0) { options = {}; }
    var subtext = options.subtext;
    if (subtext == null) {
        return component;
    }
    var style = options.style;
    var isOuter = options.label == null && options.aside == null;
    var className = classnames(subdued$1, subtext$1, isOuter && options.className);
    return (createElement("div", { className: mtrFormField, style: isOuter ? style : undefined },
        component,
        subtext ? createElement("p", { className: className }, subtext) : undefined));
}
function addLabel(component, options) {
    if (options === void 0) { options = {}; }
    var _a;
    if (options.label == null && options.aside == null) {
        return component;
    }
    var checkbox = options.checkbox, style = options.style;
    var className = classnames(mtrFormLabel, options.className, (_a = {},
        _a[mtrFormLabelHorizontal] = options.horizontal || checkbox,
        _a[mtrFormLabelCheckbox] = checkbox,
        _a[mtrFormLabelInline] = options.inline,
        _a));
    return (createElement("label", { className: className, style: style }, checkbox
        ? renderLabeledCheckbox(component, options)
        : renderLabeledControl(component, options)));
}
/**
 * Indicate whether a given component will be wrapped by a label and/or subtext
 */
// tslint:disable-next-line:no-any
function isWrapped(props) {
    var label = props.label, aside = props.aside, subtext = props.subtext;
    return label != null || aside != null || subtext != null;
}
function ToggledInput(props) {
    var type = props.type, checked = props.checked, defaultChecked = props.defaultChecked, value = props.value, disabled = props.disabled, name = props.name, onChange = props.onChange, mainClass = props.mainClass, backdropClass = props.backdropClass, label = props.label, style = props.style;
    var className = classnames(mainClass, label == null && props.className);
    return addLabel(createElement("div", { className: className, style: label == null ? style : undefined },
        createElement("input", { type: type, name: name, value: value, defaultChecked: defaultChecked, checked: checked, disabled: disabled, onChange: onChange }),
        createElement("div", { className: backdropClass })), __assign({}, props, { checkbox: true }));
}
function renderLabeledCheckbox(component, options) {
    var label = options.label;
    return (createElement(Fragment, null,
        component,
        label ? (createElement("span", { className: mtrFormLabelText }, label)) : (undefined)));
}
function renderLabeledControl(component, options) {
    var label = options.label, aside = options.aside;
    return (createElement(Fragment, null,
        label || aside ? (createElement("span", { className: mtrFormLabelText },
            label,
            aside &&
                !options.horizontal && (createElement("span", { className: mtrFormLabelTextAside }, aside)))) : (undefined),
        component));
}

/**
 * A Checkbox is a togglable form control.
 */
function Checkbox(props) {
    return ToggledInput(__assign({}, props, { type: 'checkbox', mainClass: mtrCheckbox, backdropClass: mtrCheckboxBackdrop }));
}

var mtrContentWell = "mtr-content-well";
var mtrContentWellOutline = "mtr-content-well--outline";
var mtrContentWellInner = "mtr-content-well__inner";

/**
 * ContentWell is used to highlight a block of content.
 */
var ContentWell = /** @class */ (function (_super) {
    __extends(ContentWell, _super);
    function ContentWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentWell.prototype.render = function () {
        var _a = this.props, children = _a.children, scrollable = _a.scrollable;
        var className = classnames(mtrContentWell, this.props.className);
        return (createElement("div", { className: className }, scrollable ? (createElement("div", { className: mtrContentWellInner }, children)) : (children)));
    };
    ContentWell.Outline = Outline;
    return ContentWell;
}(Component));
function Outline(props) {
    var className = classnames(mtrContentWellOutline, props.className);
    return createElement("div", { className: className }, props.children);
}

/**
 * An Input is a single line text input.
 */
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.setState({ value: event.currentTarget.value });
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        _this.state = {
            value: props.value
        };
        return _this;
    }
    Input.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }
    };
    Input.prototype.render = function () {
        var _a = this.props, autoFocus = _a.autoFocus, disabled = _a.disabled, name = _a.name, placeholder = _a.placeholder, size = _a.size, _b = _a.type, type = _b === void 0 ? 'text' : _b, style = _a.style, onBlur = _a.onBlur, onKeyPress = _a.onKeyPress;
        var wrapped = isWrapped(this.props);
        var className = classnames(mtrFormControl, getSizeClass$2(size), !wrapped && this.props.className);
        var input = (createElement("input", { className: className, type: type, autoFocus: autoFocus, name: name, placeholder: placeholder, value: this.state.value || '', disabled: disabled, onChange: this.handleChange, onBlur: onBlur, onKeyPress: onKeyPress, style: wrapped ? undefined : style }));
        return addLabel(addSubtext(input, this.props), this.props);
    };
    return Input;
}(Component));

var mtrRadio$1 = "mtr-radio";
var mtrRadioBackdrop = "mtr-radio__backdrop";

/**
 * A Radio is a selectable form control.
 */
function Radio(props) {
    return ToggledInput(__assign({}, props, { type: 'radio', mainClass: mtrRadio$1, backdropClass: mtrRadioBackdrop }));
}

/**
 * A Select allows a single value to be selected from a dropdown menu.
 */
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, style = _a.style, inline = _a.inline, name = _a.name, onChange = _a.onChange, size = _a.size, value = _a.value;
        var wrapped = isWrapped(this.props);
        var className = classnames(mtrFormControl, getSizeClass$2(size), !wrapped && this.props.className, inline && mtrFormControlInline);
        var select = (createElement("select", { className: className, style: wrapped ? undefined : style, name: name, value: onChange ? value : undefined, defaultValue: onChange ? undefined : value, disabled: disabled, onChange: onChange }, this.props.children));
        return addLabel(addSubtext(select, this.props), this.props);
    };
    Select.Option = SelectOption;
    return Select;
}(Component));
function SelectOption(props) {
    var disabled = props.disabled, value = props.value, label = props.label;
    return (createElement("option", { disabled: disabled, value: value || label }, label || value));
}

/**
 * A Form is a group of form control components.
 */
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Form.prototype.render = function () {
        var _a = this.props, style = _a.style, onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? {} : _b;
        var className = classnames(mtrForm, this.props.className);
        return (createElement("form", { className: className, onChange: onChange, style: style }, Children.map(this.props.children, function (child) {
            if (typeof child === 'string' ||
                typeof child === 'number' ||
                !child.props.name) {
                return child;
            }
            else {
                return cloneElement(child, {
                    value: value[child.props.name],
                    onChange: onChange
                });
            }
        })));
    };
    // Make control components available on Form for convenience
    Form.Button = Button;
    Form.Checkbox = Checkbox;
    Form.Input = Input;
    Form.Radio = Radio;
    Form.Select = Select;
    // Expose the grouping component
    Form.Group = FormGroup;
    Form.Options = FormOptions;
    return Form;
}(Component));
function FormGroup(props) {
    var wrapped = isWrapped(props);
    var inline = props.inline, prompt = props.prompt, children = props.children, style = props.style, size = props.size;
    var className = classnames(mtrFormControlGroup, !wrapped && props.className, inline && mtrFormControlGroupInline);
    var component = (createElement("div", { className: className, style: wrapped ? undefined : style },
        prompt && (createElement("span", { className: getFormControlDescriptorClasses(size) }, prompt)),
        Children.map(children, function (child) {
            if (typeof child === 'string' || typeof child === 'number' || !size) {
                return child;
            }
            else {
                return cloneElement(child, {
                    size: size
                });
            }
        })));
    return addLabel(addSubtext(component, props), props);
}
function getFormControlDescriptorClasses(size) {
    var _a;
    return classnames(mtrFormControlDescriptor, (_a = {},
        _a[mtrFormControlDescriptorSm] = size === 'sm',
        _a[mtrFormControlDescriptorMd] = size === 'md',
        _a[mtrFormControlDescriptorLg] = size === 'lg',
        _a));
}
function FormOptions(props) {
    var children = props.children, stacked = props.stacked, style = props.style;
    var wrapped = isWrapped(props);
    var className = classnames(mtrFormOptionsGroup, stacked && mtrFormOptionsGroupStacked, !wrapped && props.className);
    var options = (createElement("div", { className: className, style: wrapped ? undefined : style }, Children.map(children, function (child) { return (createElement("div", { className: mtrFormOptionsItem }, child)); })));
    return addLabel(addSubtext(options, props), props);
}

/**
 * Heading is a page or section heading
 */
function Heading(props) {
    var _a;
    var style = props.style, size = props.size, id = props.id, underlined = props.underlined, inverted = props.inverted, bold = props.bold;
    var className = classnames(mtrHeading, getSizeClass$3(size), (_a = {},
        _a[mtrHeadingUnderlined] = underlined,
        _a[mtrHeadingInverted] = inverted,
        _a[mtrHeadingBold] = bold,
        _a), props.className);
    var headingProps = { id: id, className: className, style: style };
    switch (size) {
        case 'xxl':
        case 'xl':
            return createElement("h1", __assign({}, headingProps), props.children);
        case 'lg':
            return createElement("h2", __assign({}, headingProps), props.children);
        case 'md':
            return createElement("h3", __assign({}, headingProps), props.children);
        case 'sm':
            return createElement("h4", __assign({}, headingProps), props.children);
        case 'xs':
            return createElement("h5", __assign({}, headingProps), props.children);
        default:
            return createElement("h6", __assign({}, headingProps), props.children);
    }
}
function getSizeClass$3(size) {
    switch (size) {
        case 'xxs':
            return mtrHeadingXxs;
        case 'xs':
            return mtrHeadingXs;
        case 'sm':
            return mtrHeadingSm;
        case 'md':
            return mtrHeadingMd;
        case 'lg':
            return mtrHeadingLg;
        case 'xl':
            return mtrHeadingXl;
        default:
            return mtrHeadingXxl;
    }
}

var paddingXxs = "padding-xxs";
var paddingXs = "padding-xs";
var paddingSm = "padding-sm";
var paddingMd = "padding-md";
var paddingLg = "padding-lg";
var paddingXl = "padding-xl";
var paddingXxl = "padding-xxl";

function getPaddingClass(size) {
    if (!size) {
        return;
    }
    switch (size) {
        case 'xxs':
            return paddingXxs;
        case 'xs':
            return paddingXs;
        case 'sm':
            return paddingSm;
        case 'md':
            return paddingMd;
        case 'lg':
            return paddingLg;
        case 'xl':
            return paddingXl;
        default:
            return paddingXxl;
    }
}

var mtrGrid = "mtr-grid";
var mtrGridContainer = "mtr-grid__container";
var mtrGridRow$1 = "mtr-grid__row";
var mtrGridRowNowrap = "mtr-grid__row--nowrap";
var mtrGridRowStacked = "mtr-grid__row--stacked";
var mtrGridRowCenter = "mtr-grid__row--center";
var mtrGridCell$1 = "mtr-grid__cell";
var mtrGridCellHide = "mtr-grid__cell--hide";
var mtrGridCellFill = "mtr-grid__cell--fill";
var mtrGridCellW10 = "mtr-grid__cell--w10";
var mtrGridCellW20 = "mtr-grid__cell--w20";
var mtrGridCellW30 = "mtr-grid__cell--w30";
var mtrGridCellW40 = "mtr-grid__cell--w40";
var mtrGridCellW50 = "mtr-grid__cell--w50";
var mtrGridCellW60 = "mtr-grid__cell--w60";
var mtrGridCellW70 = "mtr-grid__cell--w70";
var mtrGridCellW80 = "mtr-grid__cell--w80";
var mtrGridCellW90 = "mtr-grid__cell--w90";
var mtrGridCellW100 = "mtr-grid__cell--w100";
var mtrGridCellW110 = "mtr-grid__cell--w110";
var mtrGridCellW120 = "mtr-grid__cell--w120";
var mtrGridCellW130 = "mtr-grid__cell--w130";
var mtrGridCellW140 = "mtr-grid__cell--w140";
var mtrGridCellW150 = "mtr-grid__cell--w150";
var mtrGridCellW160 = "mtr-grid__cell--w160";
var mtrGridCellW170 = "mtr-grid__cell--w170";
var mtrGridCellW180 = "mtr-grid__cell--w180";
var mtrGridCellW190 = "mtr-grid__cell--w190";
var mtrGridCellW200 = "mtr-grid__cell--w200";
var mtrGridCellW210 = "mtr-grid__cell--w210";
var mtrGridCellW220 = "mtr-grid__cell--w220";
var mtrGridCellW230 = "mtr-grid__cell--w230";
var mtrGridCellW240 = "mtr-grid__cell--w240";
var mtrGridCellW250 = "mtr-grid__cell--w250";
var mtrGridCellW260 = "mtr-grid__cell--w260";
var mtrGridCellW270 = "mtr-grid__cell--w270";
var mtrGridCellW280 = "mtr-grid__cell--w280";
var mtrGridCellW290 = "mtr-grid__cell--w290";
var mtrGridCellW300 = "mtr-grid__cell--w300";
var mtrGridCellW310 = "mtr-grid__cell--w310";
var mtrGridCellW320 = "mtr-grid__cell--w320";
var mtrGridCellW330 = "mtr-grid__cell--w330";
var mtrGridCellW340 = "mtr-grid__cell--w340";
var mtrGridCellW350 = "mtr-grid__cell--w350";
var mtrGridCellW360 = "mtr-grid__cell--w360";
var mtrGridCellW370 = "mtr-grid__cell--w370";
var mtrGridCellW380 = "mtr-grid__cell--w380";
var mtrGridCellW390 = "mtr-grid__cell--w390";
var mtrGridCellW400 = "mtr-grid__cell--w400";
var mtrGridCellW410 = "mtr-grid__cell--w410";
var mtrGridCellW420 = "mtr-grid__cell--w420";
var mtrGridCellW430 = "mtr-grid__cell--w430";
var mtrGridCellW440 = "mtr-grid__cell--w440";
var mtrGridCellW450 = "mtr-grid__cell--w450";
var mtrGridCellW460 = "mtr-grid__cell--w460";
var mtrGridCellW470 = "mtr-grid__cell--w470";
var mtrGridCellW480 = "mtr-grid__cell--w480";
var mtrGridCellW490 = "mtr-grid__cell--w490";
var mtrGridCellW500 = "mtr-grid__cell--w500";
var mtrGridCellW510 = "mtr-grid__cell--w510";
var mtrGridCellW520 = "mtr-grid__cell--w520";
var mtrGridCellW530 = "mtr-grid__cell--w530";
var mtrGridCellW540 = "mtr-grid__cell--w540";
var mtrGridCellW550 = "mtr-grid__cell--w550";
var mtrGridCellW560 = "mtr-grid__cell--w560";
var mtrGridCellW570 = "mtr-grid__cell--w570";
var mtrGridCellW580 = "mtr-grid__cell--w580";
var mtrGridCellW590 = "mtr-grid__cell--w590";
var mtrGridCellW600 = "mtr-grid__cell--w600";
var mtrGridCellW610 = "mtr-grid__cell--w610";
var mtrGridCellW620 = "mtr-grid__cell--w620";
var mtrGridCellW630 = "mtr-grid__cell--w630";
var mtrGridCellW640 = "mtr-grid__cell--w640";
var mtrGridCellW650 = "mtr-grid__cell--w650";
var mtrGridCellW660 = "mtr-grid__cell--w660";
var mtrGridCellW670 = "mtr-grid__cell--w670";
var mtrGridCellW680 = "mtr-grid__cell--w680";
var mtrGridCellW690 = "mtr-grid__cell--w690";
var mtrGridCellW700 = "mtr-grid__cell--w700";
var mtrGridCellW710 = "mtr-grid__cell--w710";
var mtrGridCellW720 = "mtr-grid__cell--w720";
var mtrGridCellW730 = "mtr-grid__cell--w730";
var mtrGridCellW740 = "mtr-grid__cell--w740";
var mtrGridCellW750 = "mtr-grid__cell--w750";
var mtrGridCellW760 = "mtr-grid__cell--w760";
var mtrGridCellW770 = "mtr-grid__cell--w770";
var mtrGridCellW780 = "mtr-grid__cell--w780";
var mtrGridCellW790 = "mtr-grid__cell--w790";
var mtrGridCellW800 = "mtr-grid__cell--w800";
var mtrGridCellW810 = "mtr-grid__cell--w810";
var mtrGridCellW820 = "mtr-grid__cell--w820";
var mtrGridCellW830 = "mtr-grid__cell--w830";
var mtrGridCellW840 = "mtr-grid__cell--w840";
var mtrGridCellW850 = "mtr-grid__cell--w850";
var mtrGridCellW860 = "mtr-grid__cell--w860";
var mtrGridCellW870 = "mtr-grid__cell--w870";
var mtrGridCellW880 = "mtr-grid__cell--w880";
var mtrGridCellW890 = "mtr-grid__cell--w890";
var mtrGridCellW900 = "mtr-grid__cell--w900";
var mtrGridCellW910 = "mtr-grid__cell--w910";
var mtrGridCellW920 = "mtr-grid__cell--w920";
var mtrGridCellW930 = "mtr-grid__cell--w930";
var mtrGridCellW940 = "mtr-grid__cell--w940";
var mtrGridCellW950 = "mtr-grid__cell--w950";
var mtrGridCellW960 = "mtr-grid__cell--w960";
var mtrGridCellW970 = "mtr-grid__cell--w970";
var mtrGridCellW980 = "mtr-grid__cell--w980";
var mtrGridCellW990 = "mtr-grid__cell--w990";
var mtrGridCellW1000 = "mtr-grid__cell--w1000";
var mtrGridCellW1010 = "mtr-grid__cell--w1010";
var mtrGridCellW1020 = "mtr-grid__cell--w1020";
var mtrGridCellW1030 = "mtr-grid__cell--w1030";
var mtrGridCellW1040 = "mtr-grid__cell--w1040";
var mtrGridCellW1050 = "mtr-grid__cell--w1050";
var mtrGridCellW1060 = "mtr-grid__cell--w1060";
var mtrGridCellW1070 = "mtr-grid__cell--w1070";
var mtrGridCellW1080 = "mtr-grid__cell--w1080";
var mtrGridCellW1090 = "mtr-grid__cell--w1090";
var mtrGridCellW1100 = "mtr-grid__cell--w1100";
var mtrGridCellW1110 = "mtr-grid__cell--w1110";
var mtrGridCellW1120 = "mtr-grid__cell--w1120";
var mtrGridCellW1130 = "mtr-grid__cell--w1130";
var mtrGridCellW1140 = "mtr-grid__cell--w1140";
var mtrGridCellW1150 = "mtr-grid__cell--w1150";
var mtrGridCellW1160 = "mtr-grid__cell--w1160";
var mtrGridCellW1170 = "mtr-grid__cell--w1170";
var mtrGridCellW1180 = "mtr-grid__cell--w1180";
var mtrGridCellW1190 = "mtr-grid__cell--w1190";
var mtrGridCellW1200 = "mtr-grid__cell--w1200";
var mtrGridCellW1210 = "mtr-grid__cell--w1210";
var mtrGridCellW1220 = "mtr-grid__cell--w1220";
var mtrGridCellW1230 = "mtr-grid__cell--w1230";
var mtrGridCellW1240 = "mtr-grid__cell--w1240";
var mtrGridCellW1250 = "mtr-grid__cell--w1250";
var mtrGridCellW1260 = "mtr-grid__cell--w1260";
var mtrGridCellW1270 = "mtr-grid__cell--w1270";
var mtrGridCellW1280 = "mtr-grid__cell--w1280";
var mtrGridCellW1290 = "mtr-grid__cell--w1290";
var mtrGridCellW1300 = "mtr-grid__cell--w1300";
var mtrGridCellW1310 = "mtr-grid__cell--w1310";
var mtrGridCellW1320 = "mtr-grid__cell--w1320";
var mtrGridCellW1330 = "mtr-grid__cell--w1330";
var mtrGridCellW1340 = "mtr-grid__cell--w1340";
var mtrGridCellW1350 = "mtr-grid__cell--w1350";
var mtrGridCellW1360 = "mtr-grid__cell--w1360";
var mtrGridCellW1370 = "mtr-grid__cell--w1370";
var mtrGridCellW1380 = "mtr-grid__cell--w1380";
var mtrGridCellW1390 = "mtr-grid__cell--w1390";
var mtrGridCellW1400 = "mtr-grid__cell--w1400";
var mtrGridCellW1410 = "mtr-grid__cell--w1410";
var mtrGridCellW1420 = "mtr-grid__cell--w1420";
var mtrGridCellW1430 = "mtr-grid__cell--w1430";
var mtrGridCellW1440 = "mtr-grid__cell--w1440";
var mtrGridCellW1450 = "mtr-grid__cell--w1450";
var mtrGridCellW1460 = "mtr-grid__cell--w1460";
var mtrGridCellW1470 = "mtr-grid__cell--w1470";
var mtrGridCellW1480 = "mtr-grid__cell--w1480";
var mtrGridCellW1490 = "mtr-grid__cell--w1490";
var mtrGridCellW1500 = "mtr-grid__cell--w1500";
var mtrGridCellW1510 = "mtr-grid__cell--w1510";
var mtrGridCellW1520 = "mtr-grid__cell--w1520";
var mtrGridCellW1530 = "mtr-grid__cell--w1530";
var mtrGridCellW1540 = "mtr-grid__cell--w1540";
var mtrGridCellW1550 = "mtr-grid__cell--w1550";
var mtrGridCellW1560 = "mtr-grid__cell--w1560";
var mtrGridCellW1570 = "mtr-grid__cell--w1570";
var mtrGridCellW1580 = "mtr-grid__cell--w1580";
var mtrGridCellW1590 = "mtr-grid__cell--w1590";
var mtrGridCellW1600 = "mtr-grid__cell--w1600";
var mtrGridCellW1610 = "mtr-grid__cell--w1610";
var mtrGridCellW1620 = "mtr-grid__cell--w1620";
var mtrGridCellW1630 = "mtr-grid__cell--w1630";
var mtrGridCellW1640 = "mtr-grid__cell--w1640";
var mtrGridCellW1650 = "mtr-grid__cell--w1650";
var mtrGridCellW1660 = "mtr-grid__cell--w1660";
var mtrGridCellW1670 = "mtr-grid__cell--w1670";
var mtrGridCellW1680 = "mtr-grid__cell--w1680";
var mtrGridCellW1690 = "mtr-grid__cell--w1690";
var mtrGridCellW1700 = "mtr-grid__cell--w1700";
var mtrGridCellW1710 = "mtr-grid__cell--w1710";
var mtrGridCellW1720 = "mtr-grid__cell--w1720";
var mtrGridCellW1730 = "mtr-grid__cell--w1730";
var mtrGridCellW1740 = "mtr-grid__cell--w1740";
var mtrGridCellW1750 = "mtr-grid__cell--w1750";
var mtrGridCellW1760 = "mtr-grid__cell--w1760";
var mtrGridCellW1770 = "mtr-grid__cell--w1770";
var mtrGridCellW1780 = "mtr-grid__cell--w1780";
var mtrGridCellW1790 = "mtr-grid__cell--w1790";
var mtrGridCellW1800 = "mtr-grid__cell--w1800";
var mtrGridCellW1810 = "mtr-grid__cell--w1810";
var mtrGridCellW1820 = "mtr-grid__cell--w1820";
var mtrGridCellW1830 = "mtr-grid__cell--w1830";
var mtrGridCellW1840 = "mtr-grid__cell--w1840";
var mtrGridCellW1850 = "mtr-grid__cell--w1850";
var mtrGridCellW1860 = "mtr-grid__cell--w1860";
var mtrGridCellW1870 = "mtr-grid__cell--w1870";
var mtrGridCellW1880 = "mtr-grid__cell--w1880";
var mtrGridCellW1890 = "mtr-grid__cell--w1890";
var mtrGridCellW1900 = "mtr-grid__cell--w1900";
var mtrGridCellW1910 = "mtr-grid__cell--w1910";
var mtrGridCellW1920 = "mtr-grid__cell--w1920";
var mtrGridCellW1930 = "mtr-grid__cell--w1930";
var mtrGridCellW1940 = "mtr-grid__cell--w1940";
var mtrGridCellW1950 = "mtr-grid__cell--w1950";
var mtrGridCellW1960 = "mtr-grid__cell--w1960";
var mtrGridCellW1970 = "mtr-grid__cell--w1970";
var mtrGridCellW1980 = "mtr-grid__cell--w1980";
var mtrGridCellW1990 = "mtr-grid__cell--w1990";
var mtrGridCell1 = "mtr-grid__cell--1";
var mtrGridCell2 = "mtr-grid__cell--2";
var mtrGridCell3 = "mtr-grid__cell--3";
var mtrGridCell4 = "mtr-grid__cell--4";
var mtrGridCell5 = "mtr-grid__cell--5";
var mtrGridCell6 = "mtr-grid__cell--6";
var mtrGridCell7 = "mtr-grid__cell--7";
var mtrGridCell8 = "mtr-grid__cell--8";
var mtrGridCell9 = "mtr-grid__cell--9";
var mtrGridCell10 = "mtr-grid__cell--10";
var mtrGridCell11 = "mtr-grid__cell--11";
var mtrGridCell12 = "mtr-grid__cell--12";
var mtrGridCellXsHide = "mtr-grid__cell--xs--hide";
var mtrGridCellXs1 = "mtr-grid__cell--xs--1";
var mtrGridCellXs2 = "mtr-grid__cell--xs--2";
var mtrGridCellXs3 = "mtr-grid__cell--xs--3";
var mtrGridCellXs4 = "mtr-grid__cell--xs--4";
var mtrGridCellXs5 = "mtr-grid__cell--xs--5";
var mtrGridCellXs6 = "mtr-grid__cell--xs--6";
var mtrGridCellXs7 = "mtr-grid__cell--xs--7";
var mtrGridCellXs8 = "mtr-grid__cell--xs--8";
var mtrGridCellXs9 = "mtr-grid__cell--xs--9";
var mtrGridCellXs10 = "mtr-grid__cell--xs--10";
var mtrGridCellXs11 = "mtr-grid__cell--xs--11";
var mtrGridCellXs12 = "mtr-grid__cell--xs--12";
var mtrGridCellSmHide = "mtr-grid__cell--sm--hide";
var mtrGridCellSm1 = "mtr-grid__cell--sm--1";
var mtrGridCellSm2 = "mtr-grid__cell--sm--2";
var mtrGridCellSm3 = "mtr-grid__cell--sm--3";
var mtrGridCellSm4 = "mtr-grid__cell--sm--4";
var mtrGridCellSm5 = "mtr-grid__cell--sm--5";
var mtrGridCellSm6 = "mtr-grid__cell--sm--6";
var mtrGridCellSm7 = "mtr-grid__cell--sm--7";
var mtrGridCellSm8 = "mtr-grid__cell--sm--8";
var mtrGridCellSm9 = "mtr-grid__cell--sm--9";
var mtrGridCellSm10 = "mtr-grid__cell--sm--10";
var mtrGridCellSm11 = "mtr-grid__cell--sm--11";
var mtrGridCellSm12 = "mtr-grid__cell--sm--12";
var mtrGridCellMdHide = "mtr-grid__cell--md--hide";
var mtrGridCellMd1 = "mtr-grid__cell--md--1";
var mtrGridCellMd2 = "mtr-grid__cell--md--2";
var mtrGridCellMd3 = "mtr-grid__cell--md--3";
var mtrGridCellMd4 = "mtr-grid__cell--md--4";
var mtrGridCellMd5 = "mtr-grid__cell--md--5";
var mtrGridCellMd6 = "mtr-grid__cell--md--6";
var mtrGridCellMd7 = "mtr-grid__cell--md--7";
var mtrGridCellMd8 = "mtr-grid__cell--md--8";
var mtrGridCellMd9 = "mtr-grid__cell--md--9";
var mtrGridCellMd10 = "mtr-grid__cell--md--10";
var mtrGridCellMd11 = "mtr-grid__cell--md--11";
var mtrGridCellMd12 = "mtr-grid__cell--md--12";
var mtrGridCellLgHide = "mtr-grid__cell--lg--hide";
var mtrGridCellLg1 = "mtr-grid__cell--lg--1";
var mtrGridCellLg2 = "mtr-grid__cell--lg--2";
var mtrGridCellLg3 = "mtr-grid__cell--lg--3";
var mtrGridCellLg4 = "mtr-grid__cell--lg--4";
var mtrGridCellLg5 = "mtr-grid__cell--lg--5";
var mtrGridCellLg6 = "mtr-grid__cell--lg--6";
var mtrGridCellLg7 = "mtr-grid__cell--lg--7";
var mtrGridCellLg8 = "mtr-grid__cell--lg--8";
var mtrGridCellLg9 = "mtr-grid__cell--lg--9";
var mtrGridCellLg10 = "mtr-grid__cell--lg--10";
var mtrGridCellLg11 = "mtr-grid__cell--lg--11";
var mtrGridCellLg12 = "mtr-grid__cell--lg--12";
var mtrGridCellXlHide = "mtr-grid__cell--xl--hide";
var mtrGridCellXl1 = "mtr-grid__cell--xl--1";
var mtrGridCellXl2 = "mtr-grid__cell--xl--2";
var mtrGridCellXl3 = "mtr-grid__cell--xl--3";
var mtrGridCellXl4 = "mtr-grid__cell--xl--4";
var mtrGridCellXl5 = "mtr-grid__cell--xl--5";
var mtrGridCellXl6 = "mtr-grid__cell--xl--6";
var mtrGridCellXl7 = "mtr-grid__cell--xl--7";
var mtrGridCellXl8 = "mtr-grid__cell--xl--8";
var mtrGridCellXl9 = "mtr-grid__cell--xl--9";
var mtrGridCellXl10 = "mtr-grid__cell--xl--10";
var mtrGridCellXl11 = "mtr-grid__cell--xl--11";
var mtrGridCellXl12 = "mtr-grid__cell--xl--12";
var mtrGridCondensed$1 = "mtr-grid--condensed";
var mtrGridCollapsed$1 = "mtr-grid--collapsed";
var LayoutGrid_module = {"mtr-grid":"mtr-grid","mtr-grid__container":"mtr-grid__container","mtr-grid__row":"mtr-grid__row","mtr-grid__row--nowrap":"mtr-grid__row--nowrap","mtr-grid__row--stacked":"mtr-grid__row--stacked","mtr-grid__row--center":"mtr-grid__row--center","mtr-grid__cell":"mtr-grid__cell","mtr-grid__cell--hide":"mtr-grid__cell--hide","mtr-grid__cell--fill":"mtr-grid__cell--fill","mtr-grid__cell--w10":"mtr-grid__cell--w10","mtr-grid__cell--w20":"mtr-grid__cell--w20","mtr-grid__cell--w30":"mtr-grid__cell--w30","mtr-grid__cell--w40":"mtr-grid__cell--w40","mtr-grid__cell--w50":"mtr-grid__cell--w50","mtr-grid__cell--w60":"mtr-grid__cell--w60","mtr-grid__cell--w70":"mtr-grid__cell--w70","mtr-grid__cell--w80":"mtr-grid__cell--w80","mtr-grid__cell--w90":"mtr-grid__cell--w90","mtr-grid__cell--w100":"mtr-grid__cell--w100","mtr-grid__cell--w110":"mtr-grid__cell--w110","mtr-grid__cell--w120":"mtr-grid__cell--w120","mtr-grid__cell--w130":"mtr-grid__cell--w130","mtr-grid__cell--w140":"mtr-grid__cell--w140","mtr-grid__cell--w150":"mtr-grid__cell--w150","mtr-grid__cell--w160":"mtr-grid__cell--w160","mtr-grid__cell--w170":"mtr-grid__cell--w170","mtr-grid__cell--w180":"mtr-grid__cell--w180","mtr-grid__cell--w190":"mtr-grid__cell--w190","mtr-grid__cell--w200":"mtr-grid__cell--w200","mtr-grid__cell--w210":"mtr-grid__cell--w210","mtr-grid__cell--w220":"mtr-grid__cell--w220","mtr-grid__cell--w230":"mtr-grid__cell--w230","mtr-grid__cell--w240":"mtr-grid__cell--w240","mtr-grid__cell--w250":"mtr-grid__cell--w250","mtr-grid__cell--w260":"mtr-grid__cell--w260","mtr-grid__cell--w270":"mtr-grid__cell--w270","mtr-grid__cell--w280":"mtr-grid__cell--w280","mtr-grid__cell--w290":"mtr-grid__cell--w290","mtr-grid__cell--w300":"mtr-grid__cell--w300","mtr-grid__cell--w310":"mtr-grid__cell--w310","mtr-grid__cell--w320":"mtr-grid__cell--w320","mtr-grid__cell--w330":"mtr-grid__cell--w330","mtr-grid__cell--w340":"mtr-grid__cell--w340","mtr-grid__cell--w350":"mtr-grid__cell--w350","mtr-grid__cell--w360":"mtr-grid__cell--w360","mtr-grid__cell--w370":"mtr-grid__cell--w370","mtr-grid__cell--w380":"mtr-grid__cell--w380","mtr-grid__cell--w390":"mtr-grid__cell--w390","mtr-grid__cell--w400":"mtr-grid__cell--w400","mtr-grid__cell--w410":"mtr-grid__cell--w410","mtr-grid__cell--w420":"mtr-grid__cell--w420","mtr-grid__cell--w430":"mtr-grid__cell--w430","mtr-grid__cell--w440":"mtr-grid__cell--w440","mtr-grid__cell--w450":"mtr-grid__cell--w450","mtr-grid__cell--w460":"mtr-grid__cell--w460","mtr-grid__cell--w470":"mtr-grid__cell--w470","mtr-grid__cell--w480":"mtr-grid__cell--w480","mtr-grid__cell--w490":"mtr-grid__cell--w490","mtr-grid__cell--w500":"mtr-grid__cell--w500","mtr-grid__cell--w510":"mtr-grid__cell--w510","mtr-grid__cell--w520":"mtr-grid__cell--w520","mtr-grid__cell--w530":"mtr-grid__cell--w530","mtr-grid__cell--w540":"mtr-grid__cell--w540","mtr-grid__cell--w550":"mtr-grid__cell--w550","mtr-grid__cell--w560":"mtr-grid__cell--w560","mtr-grid__cell--w570":"mtr-grid__cell--w570","mtr-grid__cell--w580":"mtr-grid__cell--w580","mtr-grid__cell--w590":"mtr-grid__cell--w590","mtr-grid__cell--w600":"mtr-grid__cell--w600","mtr-grid__cell--w610":"mtr-grid__cell--w610","mtr-grid__cell--w620":"mtr-grid__cell--w620","mtr-grid__cell--w630":"mtr-grid__cell--w630","mtr-grid__cell--w640":"mtr-grid__cell--w640","mtr-grid__cell--w650":"mtr-grid__cell--w650","mtr-grid__cell--w660":"mtr-grid__cell--w660","mtr-grid__cell--w670":"mtr-grid__cell--w670","mtr-grid__cell--w680":"mtr-grid__cell--w680","mtr-grid__cell--w690":"mtr-grid__cell--w690","mtr-grid__cell--w700":"mtr-grid__cell--w700","mtr-grid__cell--w710":"mtr-grid__cell--w710","mtr-grid__cell--w720":"mtr-grid__cell--w720","mtr-grid__cell--w730":"mtr-grid__cell--w730","mtr-grid__cell--w740":"mtr-grid__cell--w740","mtr-grid__cell--w750":"mtr-grid__cell--w750","mtr-grid__cell--w760":"mtr-grid__cell--w760","mtr-grid__cell--w770":"mtr-grid__cell--w770","mtr-grid__cell--w780":"mtr-grid__cell--w780","mtr-grid__cell--w790":"mtr-grid__cell--w790","mtr-grid__cell--w800":"mtr-grid__cell--w800","mtr-grid__cell--w810":"mtr-grid__cell--w810","mtr-grid__cell--w820":"mtr-grid__cell--w820","mtr-grid__cell--w830":"mtr-grid__cell--w830","mtr-grid__cell--w840":"mtr-grid__cell--w840","mtr-grid__cell--w850":"mtr-grid__cell--w850","mtr-grid__cell--w860":"mtr-grid__cell--w860","mtr-grid__cell--w870":"mtr-grid__cell--w870","mtr-grid__cell--w880":"mtr-grid__cell--w880","mtr-grid__cell--w890":"mtr-grid__cell--w890","mtr-grid__cell--w900":"mtr-grid__cell--w900","mtr-grid__cell--w910":"mtr-grid__cell--w910","mtr-grid__cell--w920":"mtr-grid__cell--w920","mtr-grid__cell--w930":"mtr-grid__cell--w930","mtr-grid__cell--w940":"mtr-grid__cell--w940","mtr-grid__cell--w950":"mtr-grid__cell--w950","mtr-grid__cell--w960":"mtr-grid__cell--w960","mtr-grid__cell--w970":"mtr-grid__cell--w970","mtr-grid__cell--w980":"mtr-grid__cell--w980","mtr-grid__cell--w990":"mtr-grid__cell--w990","mtr-grid__cell--w1000":"mtr-grid__cell--w1000","mtr-grid__cell--w1010":"mtr-grid__cell--w1010","mtr-grid__cell--w1020":"mtr-grid__cell--w1020","mtr-grid__cell--w1030":"mtr-grid__cell--w1030","mtr-grid__cell--w1040":"mtr-grid__cell--w1040","mtr-grid__cell--w1050":"mtr-grid__cell--w1050","mtr-grid__cell--w1060":"mtr-grid__cell--w1060","mtr-grid__cell--w1070":"mtr-grid__cell--w1070","mtr-grid__cell--w1080":"mtr-grid__cell--w1080","mtr-grid__cell--w1090":"mtr-grid__cell--w1090","mtr-grid__cell--w1100":"mtr-grid__cell--w1100","mtr-grid__cell--w1110":"mtr-grid__cell--w1110","mtr-grid__cell--w1120":"mtr-grid__cell--w1120","mtr-grid__cell--w1130":"mtr-grid__cell--w1130","mtr-grid__cell--w1140":"mtr-grid__cell--w1140","mtr-grid__cell--w1150":"mtr-grid__cell--w1150","mtr-grid__cell--w1160":"mtr-grid__cell--w1160","mtr-grid__cell--w1170":"mtr-grid__cell--w1170","mtr-grid__cell--w1180":"mtr-grid__cell--w1180","mtr-grid__cell--w1190":"mtr-grid__cell--w1190","mtr-grid__cell--w1200":"mtr-grid__cell--w1200","mtr-grid__cell--w1210":"mtr-grid__cell--w1210","mtr-grid__cell--w1220":"mtr-grid__cell--w1220","mtr-grid__cell--w1230":"mtr-grid__cell--w1230","mtr-grid__cell--w1240":"mtr-grid__cell--w1240","mtr-grid__cell--w1250":"mtr-grid__cell--w1250","mtr-grid__cell--w1260":"mtr-grid__cell--w1260","mtr-grid__cell--w1270":"mtr-grid__cell--w1270","mtr-grid__cell--w1280":"mtr-grid__cell--w1280","mtr-grid__cell--w1290":"mtr-grid__cell--w1290","mtr-grid__cell--w1300":"mtr-grid__cell--w1300","mtr-grid__cell--w1310":"mtr-grid__cell--w1310","mtr-grid__cell--w1320":"mtr-grid__cell--w1320","mtr-grid__cell--w1330":"mtr-grid__cell--w1330","mtr-grid__cell--w1340":"mtr-grid__cell--w1340","mtr-grid__cell--w1350":"mtr-grid__cell--w1350","mtr-grid__cell--w1360":"mtr-grid__cell--w1360","mtr-grid__cell--w1370":"mtr-grid__cell--w1370","mtr-grid__cell--w1380":"mtr-grid__cell--w1380","mtr-grid__cell--w1390":"mtr-grid__cell--w1390","mtr-grid__cell--w1400":"mtr-grid__cell--w1400","mtr-grid__cell--w1410":"mtr-grid__cell--w1410","mtr-grid__cell--w1420":"mtr-grid__cell--w1420","mtr-grid__cell--w1430":"mtr-grid__cell--w1430","mtr-grid__cell--w1440":"mtr-grid__cell--w1440","mtr-grid__cell--w1450":"mtr-grid__cell--w1450","mtr-grid__cell--w1460":"mtr-grid__cell--w1460","mtr-grid__cell--w1470":"mtr-grid__cell--w1470","mtr-grid__cell--w1480":"mtr-grid__cell--w1480","mtr-grid__cell--w1490":"mtr-grid__cell--w1490","mtr-grid__cell--w1500":"mtr-grid__cell--w1500","mtr-grid__cell--w1510":"mtr-grid__cell--w1510","mtr-grid__cell--w1520":"mtr-grid__cell--w1520","mtr-grid__cell--w1530":"mtr-grid__cell--w1530","mtr-grid__cell--w1540":"mtr-grid__cell--w1540","mtr-grid__cell--w1550":"mtr-grid__cell--w1550","mtr-grid__cell--w1560":"mtr-grid__cell--w1560","mtr-grid__cell--w1570":"mtr-grid__cell--w1570","mtr-grid__cell--w1580":"mtr-grid__cell--w1580","mtr-grid__cell--w1590":"mtr-grid__cell--w1590","mtr-grid__cell--w1600":"mtr-grid__cell--w1600","mtr-grid__cell--w1610":"mtr-grid__cell--w1610","mtr-grid__cell--w1620":"mtr-grid__cell--w1620","mtr-grid__cell--w1630":"mtr-grid__cell--w1630","mtr-grid__cell--w1640":"mtr-grid__cell--w1640","mtr-grid__cell--w1650":"mtr-grid__cell--w1650","mtr-grid__cell--w1660":"mtr-grid__cell--w1660","mtr-grid__cell--w1670":"mtr-grid__cell--w1670","mtr-grid__cell--w1680":"mtr-grid__cell--w1680","mtr-grid__cell--w1690":"mtr-grid__cell--w1690","mtr-grid__cell--w1700":"mtr-grid__cell--w1700","mtr-grid__cell--w1710":"mtr-grid__cell--w1710","mtr-grid__cell--w1720":"mtr-grid__cell--w1720","mtr-grid__cell--w1730":"mtr-grid__cell--w1730","mtr-grid__cell--w1740":"mtr-grid__cell--w1740","mtr-grid__cell--w1750":"mtr-grid__cell--w1750","mtr-grid__cell--w1760":"mtr-grid__cell--w1760","mtr-grid__cell--w1770":"mtr-grid__cell--w1770","mtr-grid__cell--w1780":"mtr-grid__cell--w1780","mtr-grid__cell--w1790":"mtr-grid__cell--w1790","mtr-grid__cell--w1800":"mtr-grid__cell--w1800","mtr-grid__cell--w1810":"mtr-grid__cell--w1810","mtr-grid__cell--w1820":"mtr-grid__cell--w1820","mtr-grid__cell--w1830":"mtr-grid__cell--w1830","mtr-grid__cell--w1840":"mtr-grid__cell--w1840","mtr-grid__cell--w1850":"mtr-grid__cell--w1850","mtr-grid__cell--w1860":"mtr-grid__cell--w1860","mtr-grid__cell--w1870":"mtr-grid__cell--w1870","mtr-grid__cell--w1880":"mtr-grid__cell--w1880","mtr-grid__cell--w1890":"mtr-grid__cell--w1890","mtr-grid__cell--w1900":"mtr-grid__cell--w1900","mtr-grid__cell--w1910":"mtr-grid__cell--w1910","mtr-grid__cell--w1920":"mtr-grid__cell--w1920","mtr-grid__cell--w1930":"mtr-grid__cell--w1930","mtr-grid__cell--w1940":"mtr-grid__cell--w1940","mtr-grid__cell--w1950":"mtr-grid__cell--w1950","mtr-grid__cell--w1960":"mtr-grid__cell--w1960","mtr-grid__cell--w1970":"mtr-grid__cell--w1970","mtr-grid__cell--w1980":"mtr-grid__cell--w1980","mtr-grid__cell--w1990":"mtr-grid__cell--w1990","mtr-grid__cell--1":"mtr-grid__cell--1","mtr-grid__cell--2":"mtr-grid__cell--2","mtr-grid__cell--3":"mtr-grid__cell--3","mtr-grid__cell--4":"mtr-grid__cell--4","mtr-grid__cell--5":"mtr-grid__cell--5","mtr-grid__cell--6":"mtr-grid__cell--6","mtr-grid__cell--7":"mtr-grid__cell--7","mtr-grid__cell--8":"mtr-grid__cell--8","mtr-grid__cell--9":"mtr-grid__cell--9","mtr-grid__cell--10":"mtr-grid__cell--10","mtr-grid__cell--11":"mtr-grid__cell--11","mtr-grid__cell--12":"mtr-grid__cell--12","mtr-grid__cell--xs--hide":"mtr-grid__cell--xs--hide","mtr-grid__cell--xs--1":"mtr-grid__cell--xs--1","mtr-grid__cell--xs--2":"mtr-grid__cell--xs--2","mtr-grid__cell--xs--3":"mtr-grid__cell--xs--3","mtr-grid__cell--xs--4":"mtr-grid__cell--xs--4","mtr-grid__cell--xs--5":"mtr-grid__cell--xs--5","mtr-grid__cell--xs--6":"mtr-grid__cell--xs--6","mtr-grid__cell--xs--7":"mtr-grid__cell--xs--7","mtr-grid__cell--xs--8":"mtr-grid__cell--xs--8","mtr-grid__cell--xs--9":"mtr-grid__cell--xs--9","mtr-grid__cell--xs--10":"mtr-grid__cell--xs--10","mtr-grid__cell--xs--11":"mtr-grid__cell--xs--11","mtr-grid__cell--xs--12":"mtr-grid__cell--xs--12","mtr-grid__cell--sm--hide":"mtr-grid__cell--sm--hide","mtr-grid__cell--sm--1":"mtr-grid__cell--sm--1","mtr-grid__cell--sm--2":"mtr-grid__cell--sm--2","mtr-grid__cell--sm--3":"mtr-grid__cell--sm--3","mtr-grid__cell--sm--4":"mtr-grid__cell--sm--4","mtr-grid__cell--sm--5":"mtr-grid__cell--sm--5","mtr-grid__cell--sm--6":"mtr-grid__cell--sm--6","mtr-grid__cell--sm--7":"mtr-grid__cell--sm--7","mtr-grid__cell--sm--8":"mtr-grid__cell--sm--8","mtr-grid__cell--sm--9":"mtr-grid__cell--sm--9","mtr-grid__cell--sm--10":"mtr-grid__cell--sm--10","mtr-grid__cell--sm--11":"mtr-grid__cell--sm--11","mtr-grid__cell--sm--12":"mtr-grid__cell--sm--12","mtr-grid__cell--md--hide":"mtr-grid__cell--md--hide","mtr-grid__cell--md--1":"mtr-grid__cell--md--1","mtr-grid__cell--md--2":"mtr-grid__cell--md--2","mtr-grid__cell--md--3":"mtr-grid__cell--md--3","mtr-grid__cell--md--4":"mtr-grid__cell--md--4","mtr-grid__cell--md--5":"mtr-grid__cell--md--5","mtr-grid__cell--md--6":"mtr-grid__cell--md--6","mtr-grid__cell--md--7":"mtr-grid__cell--md--7","mtr-grid__cell--md--8":"mtr-grid__cell--md--8","mtr-grid__cell--md--9":"mtr-grid__cell--md--9","mtr-grid__cell--md--10":"mtr-grid__cell--md--10","mtr-grid__cell--md--11":"mtr-grid__cell--md--11","mtr-grid__cell--md--12":"mtr-grid__cell--md--12","mtr-grid__cell--lg--hide":"mtr-grid__cell--lg--hide","mtr-grid__cell--lg--1":"mtr-grid__cell--lg--1","mtr-grid__cell--lg--2":"mtr-grid__cell--lg--2","mtr-grid__cell--lg--3":"mtr-grid__cell--lg--3","mtr-grid__cell--lg--4":"mtr-grid__cell--lg--4","mtr-grid__cell--lg--5":"mtr-grid__cell--lg--5","mtr-grid__cell--lg--6":"mtr-grid__cell--lg--6","mtr-grid__cell--lg--7":"mtr-grid__cell--lg--7","mtr-grid__cell--lg--8":"mtr-grid__cell--lg--8","mtr-grid__cell--lg--9":"mtr-grid__cell--lg--9","mtr-grid__cell--lg--10":"mtr-grid__cell--lg--10","mtr-grid__cell--lg--11":"mtr-grid__cell--lg--11","mtr-grid__cell--lg--12":"mtr-grid__cell--lg--12","mtr-grid__cell--xl--hide":"mtr-grid__cell--xl--hide","mtr-grid__cell--xl--1":"mtr-grid__cell--xl--1","mtr-grid__cell--xl--2":"mtr-grid__cell--xl--2","mtr-grid__cell--xl--3":"mtr-grid__cell--xl--3","mtr-grid__cell--xl--4":"mtr-grid__cell--xl--4","mtr-grid__cell--xl--5":"mtr-grid__cell--xl--5","mtr-grid__cell--xl--6":"mtr-grid__cell--xl--6","mtr-grid__cell--xl--7":"mtr-grid__cell--xl--7","mtr-grid__cell--xl--8":"mtr-grid__cell--xl--8","mtr-grid__cell--xl--9":"mtr-grid__cell--xl--9","mtr-grid__cell--xl--10":"mtr-grid__cell--xl--10","mtr-grid__cell--xl--11":"mtr-grid__cell--xl--11","mtr-grid__cell--xl--12":"mtr-grid__cell--xl--12","mtr-grid--condensed":"mtr-grid--condensed","mtr-grid--collapsed":"mtr-grid--collapsed","mtrGrid":"mtr-grid","mtrGridContainer":"mtr-grid__container","mtrGridRow":"mtr-grid__row","mtrGridRowNowrap":"mtr-grid__row--nowrap","mtrGridRowStacked":"mtr-grid__row--stacked","mtrGridRowCenter":"mtr-grid__row--center","mtrGridCell":"mtr-grid__cell","mtrGridCellHide":"mtr-grid__cell--hide","mtrGridCellFill":"mtr-grid__cell--fill","mtrGridCellW10":"mtr-grid__cell--w10","mtrGridCellW20":"mtr-grid__cell--w20","mtrGridCellW30":"mtr-grid__cell--w30","mtrGridCellW40":"mtr-grid__cell--w40","mtrGridCellW50":"mtr-grid__cell--w50","mtrGridCellW60":"mtr-grid__cell--w60","mtrGridCellW70":"mtr-grid__cell--w70","mtrGridCellW80":"mtr-grid__cell--w80","mtrGridCellW90":"mtr-grid__cell--w90","mtrGridCellW100":"mtr-grid__cell--w100","mtrGridCellW110":"mtr-grid__cell--w110","mtrGridCellW120":"mtr-grid__cell--w120","mtrGridCellW130":"mtr-grid__cell--w130","mtrGridCellW140":"mtr-grid__cell--w140","mtrGridCellW150":"mtr-grid__cell--w150","mtrGridCellW160":"mtr-grid__cell--w160","mtrGridCellW170":"mtr-grid__cell--w170","mtrGridCellW180":"mtr-grid__cell--w180","mtrGridCellW190":"mtr-grid__cell--w190","mtrGridCellW200":"mtr-grid__cell--w200","mtrGridCellW210":"mtr-grid__cell--w210","mtrGridCellW220":"mtr-grid__cell--w220","mtrGridCellW230":"mtr-grid__cell--w230","mtrGridCellW240":"mtr-grid__cell--w240","mtrGridCellW250":"mtr-grid__cell--w250","mtrGridCellW260":"mtr-grid__cell--w260","mtrGridCellW270":"mtr-grid__cell--w270","mtrGridCellW280":"mtr-grid__cell--w280","mtrGridCellW290":"mtr-grid__cell--w290","mtrGridCellW300":"mtr-grid__cell--w300","mtrGridCellW310":"mtr-grid__cell--w310","mtrGridCellW320":"mtr-grid__cell--w320","mtrGridCellW330":"mtr-grid__cell--w330","mtrGridCellW340":"mtr-grid__cell--w340","mtrGridCellW350":"mtr-grid__cell--w350","mtrGridCellW360":"mtr-grid__cell--w360","mtrGridCellW370":"mtr-grid__cell--w370","mtrGridCellW380":"mtr-grid__cell--w380","mtrGridCellW390":"mtr-grid__cell--w390","mtrGridCellW400":"mtr-grid__cell--w400","mtrGridCellW410":"mtr-grid__cell--w410","mtrGridCellW420":"mtr-grid__cell--w420","mtrGridCellW430":"mtr-grid__cell--w430","mtrGridCellW440":"mtr-grid__cell--w440","mtrGridCellW450":"mtr-grid__cell--w450","mtrGridCellW460":"mtr-grid__cell--w460","mtrGridCellW470":"mtr-grid__cell--w470","mtrGridCellW480":"mtr-grid__cell--w480","mtrGridCellW490":"mtr-grid__cell--w490","mtrGridCellW500":"mtr-grid__cell--w500","mtrGridCellW510":"mtr-grid__cell--w510","mtrGridCellW520":"mtr-grid__cell--w520","mtrGridCellW530":"mtr-grid__cell--w530","mtrGridCellW540":"mtr-grid__cell--w540","mtrGridCellW550":"mtr-grid__cell--w550","mtrGridCellW560":"mtr-grid__cell--w560","mtrGridCellW570":"mtr-grid__cell--w570","mtrGridCellW580":"mtr-grid__cell--w580","mtrGridCellW590":"mtr-grid__cell--w590","mtrGridCellW600":"mtr-grid__cell--w600","mtrGridCellW610":"mtr-grid__cell--w610","mtrGridCellW620":"mtr-grid__cell--w620","mtrGridCellW630":"mtr-grid__cell--w630","mtrGridCellW640":"mtr-grid__cell--w640","mtrGridCellW650":"mtr-grid__cell--w650","mtrGridCellW660":"mtr-grid__cell--w660","mtrGridCellW670":"mtr-grid__cell--w670","mtrGridCellW680":"mtr-grid__cell--w680","mtrGridCellW690":"mtr-grid__cell--w690","mtrGridCellW700":"mtr-grid__cell--w700","mtrGridCellW710":"mtr-grid__cell--w710","mtrGridCellW720":"mtr-grid__cell--w720","mtrGridCellW730":"mtr-grid__cell--w730","mtrGridCellW740":"mtr-grid__cell--w740","mtrGridCellW750":"mtr-grid__cell--w750","mtrGridCellW760":"mtr-grid__cell--w760","mtrGridCellW770":"mtr-grid__cell--w770","mtrGridCellW780":"mtr-grid__cell--w780","mtrGridCellW790":"mtr-grid__cell--w790","mtrGridCellW800":"mtr-grid__cell--w800","mtrGridCellW810":"mtr-grid__cell--w810","mtrGridCellW820":"mtr-grid__cell--w820","mtrGridCellW830":"mtr-grid__cell--w830","mtrGridCellW840":"mtr-grid__cell--w840","mtrGridCellW850":"mtr-grid__cell--w850","mtrGridCellW860":"mtr-grid__cell--w860","mtrGridCellW870":"mtr-grid__cell--w870","mtrGridCellW880":"mtr-grid__cell--w880","mtrGridCellW890":"mtr-grid__cell--w890","mtrGridCellW900":"mtr-grid__cell--w900","mtrGridCellW910":"mtr-grid__cell--w910","mtrGridCellW920":"mtr-grid__cell--w920","mtrGridCellW930":"mtr-grid__cell--w930","mtrGridCellW940":"mtr-grid__cell--w940","mtrGridCellW950":"mtr-grid__cell--w950","mtrGridCellW960":"mtr-grid__cell--w960","mtrGridCellW970":"mtr-grid__cell--w970","mtrGridCellW980":"mtr-grid__cell--w980","mtrGridCellW990":"mtr-grid__cell--w990","mtrGridCellW1000":"mtr-grid__cell--w1000","mtrGridCellW1010":"mtr-grid__cell--w1010","mtrGridCellW1020":"mtr-grid__cell--w1020","mtrGridCellW1030":"mtr-grid__cell--w1030","mtrGridCellW1040":"mtr-grid__cell--w1040","mtrGridCellW1050":"mtr-grid__cell--w1050","mtrGridCellW1060":"mtr-grid__cell--w1060","mtrGridCellW1070":"mtr-grid__cell--w1070","mtrGridCellW1080":"mtr-grid__cell--w1080","mtrGridCellW1090":"mtr-grid__cell--w1090","mtrGridCellW1100":"mtr-grid__cell--w1100","mtrGridCellW1110":"mtr-grid__cell--w1110","mtrGridCellW1120":"mtr-grid__cell--w1120","mtrGridCellW1130":"mtr-grid__cell--w1130","mtrGridCellW1140":"mtr-grid__cell--w1140","mtrGridCellW1150":"mtr-grid__cell--w1150","mtrGridCellW1160":"mtr-grid__cell--w1160","mtrGridCellW1170":"mtr-grid__cell--w1170","mtrGridCellW1180":"mtr-grid__cell--w1180","mtrGridCellW1190":"mtr-grid__cell--w1190","mtrGridCellW1200":"mtr-grid__cell--w1200","mtrGridCellW1210":"mtr-grid__cell--w1210","mtrGridCellW1220":"mtr-grid__cell--w1220","mtrGridCellW1230":"mtr-grid__cell--w1230","mtrGridCellW1240":"mtr-grid__cell--w1240","mtrGridCellW1250":"mtr-grid__cell--w1250","mtrGridCellW1260":"mtr-grid__cell--w1260","mtrGridCellW1270":"mtr-grid__cell--w1270","mtrGridCellW1280":"mtr-grid__cell--w1280","mtrGridCellW1290":"mtr-grid__cell--w1290","mtrGridCellW1300":"mtr-grid__cell--w1300","mtrGridCellW1310":"mtr-grid__cell--w1310","mtrGridCellW1320":"mtr-grid__cell--w1320","mtrGridCellW1330":"mtr-grid__cell--w1330","mtrGridCellW1340":"mtr-grid__cell--w1340","mtrGridCellW1350":"mtr-grid__cell--w1350","mtrGridCellW1360":"mtr-grid__cell--w1360","mtrGridCellW1370":"mtr-grid__cell--w1370","mtrGridCellW1380":"mtr-grid__cell--w1380","mtrGridCellW1390":"mtr-grid__cell--w1390","mtrGridCellW1400":"mtr-grid__cell--w1400","mtrGridCellW1410":"mtr-grid__cell--w1410","mtrGridCellW1420":"mtr-grid__cell--w1420","mtrGridCellW1430":"mtr-grid__cell--w1430","mtrGridCellW1440":"mtr-grid__cell--w1440","mtrGridCellW1450":"mtr-grid__cell--w1450","mtrGridCellW1460":"mtr-grid__cell--w1460","mtrGridCellW1470":"mtr-grid__cell--w1470","mtrGridCellW1480":"mtr-grid__cell--w1480","mtrGridCellW1490":"mtr-grid__cell--w1490","mtrGridCellW1500":"mtr-grid__cell--w1500","mtrGridCellW1510":"mtr-grid__cell--w1510","mtrGridCellW1520":"mtr-grid__cell--w1520","mtrGridCellW1530":"mtr-grid__cell--w1530","mtrGridCellW1540":"mtr-grid__cell--w1540","mtrGridCellW1550":"mtr-grid__cell--w1550","mtrGridCellW1560":"mtr-grid__cell--w1560","mtrGridCellW1570":"mtr-grid__cell--w1570","mtrGridCellW1580":"mtr-grid__cell--w1580","mtrGridCellW1590":"mtr-grid__cell--w1590","mtrGridCellW1600":"mtr-grid__cell--w1600","mtrGridCellW1610":"mtr-grid__cell--w1610","mtrGridCellW1620":"mtr-grid__cell--w1620","mtrGridCellW1630":"mtr-grid__cell--w1630","mtrGridCellW1640":"mtr-grid__cell--w1640","mtrGridCellW1650":"mtr-grid__cell--w1650","mtrGridCellW1660":"mtr-grid__cell--w1660","mtrGridCellW1670":"mtr-grid__cell--w1670","mtrGridCellW1680":"mtr-grid__cell--w1680","mtrGridCellW1690":"mtr-grid__cell--w1690","mtrGridCellW1700":"mtr-grid__cell--w1700","mtrGridCellW1710":"mtr-grid__cell--w1710","mtrGridCellW1720":"mtr-grid__cell--w1720","mtrGridCellW1730":"mtr-grid__cell--w1730","mtrGridCellW1740":"mtr-grid__cell--w1740","mtrGridCellW1750":"mtr-grid__cell--w1750","mtrGridCellW1760":"mtr-grid__cell--w1760","mtrGridCellW1770":"mtr-grid__cell--w1770","mtrGridCellW1780":"mtr-grid__cell--w1780","mtrGridCellW1790":"mtr-grid__cell--w1790","mtrGridCellW1800":"mtr-grid__cell--w1800","mtrGridCellW1810":"mtr-grid__cell--w1810","mtrGridCellW1820":"mtr-grid__cell--w1820","mtrGridCellW1830":"mtr-grid__cell--w1830","mtrGridCellW1840":"mtr-grid__cell--w1840","mtrGridCellW1850":"mtr-grid__cell--w1850","mtrGridCellW1860":"mtr-grid__cell--w1860","mtrGridCellW1870":"mtr-grid__cell--w1870","mtrGridCellW1880":"mtr-grid__cell--w1880","mtrGridCellW1890":"mtr-grid__cell--w1890","mtrGridCellW1900":"mtr-grid__cell--w1900","mtrGridCellW1910":"mtr-grid__cell--w1910","mtrGridCellW1920":"mtr-grid__cell--w1920","mtrGridCellW1930":"mtr-grid__cell--w1930","mtrGridCellW1940":"mtr-grid__cell--w1940","mtrGridCellW1950":"mtr-grid__cell--w1950","mtrGridCellW1960":"mtr-grid__cell--w1960","mtrGridCellW1970":"mtr-grid__cell--w1970","mtrGridCellW1980":"mtr-grid__cell--w1980","mtrGridCellW1990":"mtr-grid__cell--w1990","mtrGridCell1":"mtr-grid__cell--1","mtrGridCell2":"mtr-grid__cell--2","mtrGridCell3":"mtr-grid__cell--3","mtrGridCell4":"mtr-grid__cell--4","mtrGridCell5":"mtr-grid__cell--5","mtrGridCell6":"mtr-grid__cell--6","mtrGridCell7":"mtr-grid__cell--7","mtrGridCell8":"mtr-grid__cell--8","mtrGridCell9":"mtr-grid__cell--9","mtrGridCell10":"mtr-grid__cell--10","mtrGridCell11":"mtr-grid__cell--11","mtrGridCell12":"mtr-grid__cell--12","mtrGridCellXsHide":"mtr-grid__cell--xs--hide","mtrGridCellXs1":"mtr-grid__cell--xs--1","mtrGridCellXs2":"mtr-grid__cell--xs--2","mtrGridCellXs3":"mtr-grid__cell--xs--3","mtrGridCellXs4":"mtr-grid__cell--xs--4","mtrGridCellXs5":"mtr-grid__cell--xs--5","mtrGridCellXs6":"mtr-grid__cell--xs--6","mtrGridCellXs7":"mtr-grid__cell--xs--7","mtrGridCellXs8":"mtr-grid__cell--xs--8","mtrGridCellXs9":"mtr-grid__cell--xs--9","mtrGridCellXs10":"mtr-grid__cell--xs--10","mtrGridCellXs11":"mtr-grid__cell--xs--11","mtrGridCellXs12":"mtr-grid__cell--xs--12","mtrGridCellSmHide":"mtr-grid__cell--sm--hide","mtrGridCellSm1":"mtr-grid__cell--sm--1","mtrGridCellSm2":"mtr-grid__cell--sm--2","mtrGridCellSm3":"mtr-grid__cell--sm--3","mtrGridCellSm4":"mtr-grid__cell--sm--4","mtrGridCellSm5":"mtr-grid__cell--sm--5","mtrGridCellSm6":"mtr-grid__cell--sm--6","mtrGridCellSm7":"mtr-grid__cell--sm--7","mtrGridCellSm8":"mtr-grid__cell--sm--8","mtrGridCellSm9":"mtr-grid__cell--sm--9","mtrGridCellSm10":"mtr-grid__cell--sm--10","mtrGridCellSm11":"mtr-grid__cell--sm--11","mtrGridCellSm12":"mtr-grid__cell--sm--12","mtrGridCellMdHide":"mtr-grid__cell--md--hide","mtrGridCellMd1":"mtr-grid__cell--md--1","mtrGridCellMd2":"mtr-grid__cell--md--2","mtrGridCellMd3":"mtr-grid__cell--md--3","mtrGridCellMd4":"mtr-grid__cell--md--4","mtrGridCellMd5":"mtr-grid__cell--md--5","mtrGridCellMd6":"mtr-grid__cell--md--6","mtrGridCellMd7":"mtr-grid__cell--md--7","mtrGridCellMd8":"mtr-grid__cell--md--8","mtrGridCellMd9":"mtr-grid__cell--md--9","mtrGridCellMd10":"mtr-grid__cell--md--10","mtrGridCellMd11":"mtr-grid__cell--md--11","mtrGridCellMd12":"mtr-grid__cell--md--12","mtrGridCellLgHide":"mtr-grid__cell--lg--hide","mtrGridCellLg1":"mtr-grid__cell--lg--1","mtrGridCellLg2":"mtr-grid__cell--lg--2","mtrGridCellLg3":"mtr-grid__cell--lg--3","mtrGridCellLg4":"mtr-grid__cell--lg--4","mtrGridCellLg5":"mtr-grid__cell--lg--5","mtrGridCellLg6":"mtr-grid__cell--lg--6","mtrGridCellLg7":"mtr-grid__cell--lg--7","mtrGridCellLg8":"mtr-grid__cell--lg--8","mtrGridCellLg9":"mtr-grid__cell--lg--9","mtrGridCellLg10":"mtr-grid__cell--lg--10","mtrGridCellLg11":"mtr-grid__cell--lg--11","mtrGridCellLg12":"mtr-grid__cell--lg--12","mtrGridCellXlHide":"mtr-grid__cell--xl--hide","mtrGridCellXl1":"mtr-grid__cell--xl--1","mtrGridCellXl2":"mtr-grid__cell--xl--2","mtrGridCellXl3":"mtr-grid__cell--xl--3","mtrGridCellXl4":"mtr-grid__cell--xl--4","mtrGridCellXl5":"mtr-grid__cell--xl--5","mtrGridCellXl6":"mtr-grid__cell--xl--6","mtrGridCellXl7":"mtr-grid__cell--xl--7","mtrGridCellXl8":"mtr-grid__cell--xl--8","mtrGridCellXl9":"mtr-grid__cell--xl--9","mtrGridCellXl10":"mtr-grid__cell--xl--10","mtrGridCellXl11":"mtr-grid__cell--xl--11","mtrGridCellXl12":"mtr-grid__cell--xl--12","mtrGridCondensed":"mtr-grid--condensed","mtrGridCollapsed":"mtr-grid--collapsed"};

var styles = /*#__PURE__*/Object.freeze({
    mtrGrid: mtrGrid,
    mtrGridContainer: mtrGridContainer,
    mtrGridRow: mtrGridRow$1,
    mtrGridRowNowrap: mtrGridRowNowrap,
    mtrGridRowStacked: mtrGridRowStacked,
    mtrGridRowCenter: mtrGridRowCenter,
    mtrGridCell: mtrGridCell$1,
    mtrGridCellHide: mtrGridCellHide,
    mtrGridCellFill: mtrGridCellFill,
    mtrGridCellW10: mtrGridCellW10,
    mtrGridCellW20: mtrGridCellW20,
    mtrGridCellW30: mtrGridCellW30,
    mtrGridCellW40: mtrGridCellW40,
    mtrGridCellW50: mtrGridCellW50,
    mtrGridCellW60: mtrGridCellW60,
    mtrGridCellW70: mtrGridCellW70,
    mtrGridCellW80: mtrGridCellW80,
    mtrGridCellW90: mtrGridCellW90,
    mtrGridCellW100: mtrGridCellW100,
    mtrGridCellW110: mtrGridCellW110,
    mtrGridCellW120: mtrGridCellW120,
    mtrGridCellW130: mtrGridCellW130,
    mtrGridCellW140: mtrGridCellW140,
    mtrGridCellW150: mtrGridCellW150,
    mtrGridCellW160: mtrGridCellW160,
    mtrGridCellW170: mtrGridCellW170,
    mtrGridCellW180: mtrGridCellW180,
    mtrGridCellW190: mtrGridCellW190,
    mtrGridCellW200: mtrGridCellW200,
    mtrGridCellW210: mtrGridCellW210,
    mtrGridCellW220: mtrGridCellW220,
    mtrGridCellW230: mtrGridCellW230,
    mtrGridCellW240: mtrGridCellW240,
    mtrGridCellW250: mtrGridCellW250,
    mtrGridCellW260: mtrGridCellW260,
    mtrGridCellW270: mtrGridCellW270,
    mtrGridCellW280: mtrGridCellW280,
    mtrGridCellW290: mtrGridCellW290,
    mtrGridCellW300: mtrGridCellW300,
    mtrGridCellW310: mtrGridCellW310,
    mtrGridCellW320: mtrGridCellW320,
    mtrGridCellW330: mtrGridCellW330,
    mtrGridCellW340: mtrGridCellW340,
    mtrGridCellW350: mtrGridCellW350,
    mtrGridCellW360: mtrGridCellW360,
    mtrGridCellW370: mtrGridCellW370,
    mtrGridCellW380: mtrGridCellW380,
    mtrGridCellW390: mtrGridCellW390,
    mtrGridCellW400: mtrGridCellW400,
    mtrGridCellW410: mtrGridCellW410,
    mtrGridCellW420: mtrGridCellW420,
    mtrGridCellW430: mtrGridCellW430,
    mtrGridCellW440: mtrGridCellW440,
    mtrGridCellW450: mtrGridCellW450,
    mtrGridCellW460: mtrGridCellW460,
    mtrGridCellW470: mtrGridCellW470,
    mtrGridCellW480: mtrGridCellW480,
    mtrGridCellW490: mtrGridCellW490,
    mtrGridCellW500: mtrGridCellW500,
    mtrGridCellW510: mtrGridCellW510,
    mtrGridCellW520: mtrGridCellW520,
    mtrGridCellW530: mtrGridCellW530,
    mtrGridCellW540: mtrGridCellW540,
    mtrGridCellW550: mtrGridCellW550,
    mtrGridCellW560: mtrGridCellW560,
    mtrGridCellW570: mtrGridCellW570,
    mtrGridCellW580: mtrGridCellW580,
    mtrGridCellW590: mtrGridCellW590,
    mtrGridCellW600: mtrGridCellW600,
    mtrGridCellW610: mtrGridCellW610,
    mtrGridCellW620: mtrGridCellW620,
    mtrGridCellW630: mtrGridCellW630,
    mtrGridCellW640: mtrGridCellW640,
    mtrGridCellW650: mtrGridCellW650,
    mtrGridCellW660: mtrGridCellW660,
    mtrGridCellW670: mtrGridCellW670,
    mtrGridCellW680: mtrGridCellW680,
    mtrGridCellW690: mtrGridCellW690,
    mtrGridCellW700: mtrGridCellW700,
    mtrGridCellW710: mtrGridCellW710,
    mtrGridCellW720: mtrGridCellW720,
    mtrGridCellW730: mtrGridCellW730,
    mtrGridCellW740: mtrGridCellW740,
    mtrGridCellW750: mtrGridCellW750,
    mtrGridCellW760: mtrGridCellW760,
    mtrGridCellW770: mtrGridCellW770,
    mtrGridCellW780: mtrGridCellW780,
    mtrGridCellW790: mtrGridCellW790,
    mtrGridCellW800: mtrGridCellW800,
    mtrGridCellW810: mtrGridCellW810,
    mtrGridCellW820: mtrGridCellW820,
    mtrGridCellW830: mtrGridCellW830,
    mtrGridCellW840: mtrGridCellW840,
    mtrGridCellW850: mtrGridCellW850,
    mtrGridCellW860: mtrGridCellW860,
    mtrGridCellW870: mtrGridCellW870,
    mtrGridCellW880: mtrGridCellW880,
    mtrGridCellW890: mtrGridCellW890,
    mtrGridCellW900: mtrGridCellW900,
    mtrGridCellW910: mtrGridCellW910,
    mtrGridCellW920: mtrGridCellW920,
    mtrGridCellW930: mtrGridCellW930,
    mtrGridCellW940: mtrGridCellW940,
    mtrGridCellW950: mtrGridCellW950,
    mtrGridCellW960: mtrGridCellW960,
    mtrGridCellW970: mtrGridCellW970,
    mtrGridCellW980: mtrGridCellW980,
    mtrGridCellW990: mtrGridCellW990,
    mtrGridCellW1000: mtrGridCellW1000,
    mtrGridCellW1010: mtrGridCellW1010,
    mtrGridCellW1020: mtrGridCellW1020,
    mtrGridCellW1030: mtrGridCellW1030,
    mtrGridCellW1040: mtrGridCellW1040,
    mtrGridCellW1050: mtrGridCellW1050,
    mtrGridCellW1060: mtrGridCellW1060,
    mtrGridCellW1070: mtrGridCellW1070,
    mtrGridCellW1080: mtrGridCellW1080,
    mtrGridCellW1090: mtrGridCellW1090,
    mtrGridCellW1100: mtrGridCellW1100,
    mtrGridCellW1110: mtrGridCellW1110,
    mtrGridCellW1120: mtrGridCellW1120,
    mtrGridCellW1130: mtrGridCellW1130,
    mtrGridCellW1140: mtrGridCellW1140,
    mtrGridCellW1150: mtrGridCellW1150,
    mtrGridCellW1160: mtrGridCellW1160,
    mtrGridCellW1170: mtrGridCellW1170,
    mtrGridCellW1180: mtrGridCellW1180,
    mtrGridCellW1190: mtrGridCellW1190,
    mtrGridCellW1200: mtrGridCellW1200,
    mtrGridCellW1210: mtrGridCellW1210,
    mtrGridCellW1220: mtrGridCellW1220,
    mtrGridCellW1230: mtrGridCellW1230,
    mtrGridCellW1240: mtrGridCellW1240,
    mtrGridCellW1250: mtrGridCellW1250,
    mtrGridCellW1260: mtrGridCellW1260,
    mtrGridCellW1270: mtrGridCellW1270,
    mtrGridCellW1280: mtrGridCellW1280,
    mtrGridCellW1290: mtrGridCellW1290,
    mtrGridCellW1300: mtrGridCellW1300,
    mtrGridCellW1310: mtrGridCellW1310,
    mtrGridCellW1320: mtrGridCellW1320,
    mtrGridCellW1330: mtrGridCellW1330,
    mtrGridCellW1340: mtrGridCellW1340,
    mtrGridCellW1350: mtrGridCellW1350,
    mtrGridCellW1360: mtrGridCellW1360,
    mtrGridCellW1370: mtrGridCellW1370,
    mtrGridCellW1380: mtrGridCellW1380,
    mtrGridCellW1390: mtrGridCellW1390,
    mtrGridCellW1400: mtrGridCellW1400,
    mtrGridCellW1410: mtrGridCellW1410,
    mtrGridCellW1420: mtrGridCellW1420,
    mtrGridCellW1430: mtrGridCellW1430,
    mtrGridCellW1440: mtrGridCellW1440,
    mtrGridCellW1450: mtrGridCellW1450,
    mtrGridCellW1460: mtrGridCellW1460,
    mtrGridCellW1470: mtrGridCellW1470,
    mtrGridCellW1480: mtrGridCellW1480,
    mtrGridCellW1490: mtrGridCellW1490,
    mtrGridCellW1500: mtrGridCellW1500,
    mtrGridCellW1510: mtrGridCellW1510,
    mtrGridCellW1520: mtrGridCellW1520,
    mtrGridCellW1530: mtrGridCellW1530,
    mtrGridCellW1540: mtrGridCellW1540,
    mtrGridCellW1550: mtrGridCellW1550,
    mtrGridCellW1560: mtrGridCellW1560,
    mtrGridCellW1570: mtrGridCellW1570,
    mtrGridCellW1580: mtrGridCellW1580,
    mtrGridCellW1590: mtrGridCellW1590,
    mtrGridCellW1600: mtrGridCellW1600,
    mtrGridCellW1610: mtrGridCellW1610,
    mtrGridCellW1620: mtrGridCellW1620,
    mtrGridCellW1630: mtrGridCellW1630,
    mtrGridCellW1640: mtrGridCellW1640,
    mtrGridCellW1650: mtrGridCellW1650,
    mtrGridCellW1660: mtrGridCellW1660,
    mtrGridCellW1670: mtrGridCellW1670,
    mtrGridCellW1680: mtrGridCellW1680,
    mtrGridCellW1690: mtrGridCellW1690,
    mtrGridCellW1700: mtrGridCellW1700,
    mtrGridCellW1710: mtrGridCellW1710,
    mtrGridCellW1720: mtrGridCellW1720,
    mtrGridCellW1730: mtrGridCellW1730,
    mtrGridCellW1740: mtrGridCellW1740,
    mtrGridCellW1750: mtrGridCellW1750,
    mtrGridCellW1760: mtrGridCellW1760,
    mtrGridCellW1770: mtrGridCellW1770,
    mtrGridCellW1780: mtrGridCellW1780,
    mtrGridCellW1790: mtrGridCellW1790,
    mtrGridCellW1800: mtrGridCellW1800,
    mtrGridCellW1810: mtrGridCellW1810,
    mtrGridCellW1820: mtrGridCellW1820,
    mtrGridCellW1830: mtrGridCellW1830,
    mtrGridCellW1840: mtrGridCellW1840,
    mtrGridCellW1850: mtrGridCellW1850,
    mtrGridCellW1860: mtrGridCellW1860,
    mtrGridCellW1870: mtrGridCellW1870,
    mtrGridCellW1880: mtrGridCellW1880,
    mtrGridCellW1890: mtrGridCellW1890,
    mtrGridCellW1900: mtrGridCellW1900,
    mtrGridCellW1910: mtrGridCellW1910,
    mtrGridCellW1920: mtrGridCellW1920,
    mtrGridCellW1930: mtrGridCellW1930,
    mtrGridCellW1940: mtrGridCellW1940,
    mtrGridCellW1950: mtrGridCellW1950,
    mtrGridCellW1960: mtrGridCellW1960,
    mtrGridCellW1970: mtrGridCellW1970,
    mtrGridCellW1980: mtrGridCellW1980,
    mtrGridCellW1990: mtrGridCellW1990,
    mtrGridCell1: mtrGridCell1,
    mtrGridCell2: mtrGridCell2,
    mtrGridCell3: mtrGridCell3,
    mtrGridCell4: mtrGridCell4,
    mtrGridCell5: mtrGridCell5,
    mtrGridCell6: mtrGridCell6,
    mtrGridCell7: mtrGridCell7,
    mtrGridCell8: mtrGridCell8,
    mtrGridCell9: mtrGridCell9,
    mtrGridCell10: mtrGridCell10,
    mtrGridCell11: mtrGridCell11,
    mtrGridCell12: mtrGridCell12,
    mtrGridCellXsHide: mtrGridCellXsHide,
    mtrGridCellXs1: mtrGridCellXs1,
    mtrGridCellXs2: mtrGridCellXs2,
    mtrGridCellXs3: mtrGridCellXs3,
    mtrGridCellXs4: mtrGridCellXs4,
    mtrGridCellXs5: mtrGridCellXs5,
    mtrGridCellXs6: mtrGridCellXs6,
    mtrGridCellXs7: mtrGridCellXs7,
    mtrGridCellXs8: mtrGridCellXs8,
    mtrGridCellXs9: mtrGridCellXs9,
    mtrGridCellXs10: mtrGridCellXs10,
    mtrGridCellXs11: mtrGridCellXs11,
    mtrGridCellXs12: mtrGridCellXs12,
    mtrGridCellSmHide: mtrGridCellSmHide,
    mtrGridCellSm1: mtrGridCellSm1,
    mtrGridCellSm2: mtrGridCellSm2,
    mtrGridCellSm3: mtrGridCellSm3,
    mtrGridCellSm4: mtrGridCellSm4,
    mtrGridCellSm5: mtrGridCellSm5,
    mtrGridCellSm6: mtrGridCellSm6,
    mtrGridCellSm7: mtrGridCellSm7,
    mtrGridCellSm8: mtrGridCellSm8,
    mtrGridCellSm9: mtrGridCellSm9,
    mtrGridCellSm10: mtrGridCellSm10,
    mtrGridCellSm11: mtrGridCellSm11,
    mtrGridCellSm12: mtrGridCellSm12,
    mtrGridCellMdHide: mtrGridCellMdHide,
    mtrGridCellMd1: mtrGridCellMd1,
    mtrGridCellMd2: mtrGridCellMd2,
    mtrGridCellMd3: mtrGridCellMd3,
    mtrGridCellMd4: mtrGridCellMd4,
    mtrGridCellMd5: mtrGridCellMd5,
    mtrGridCellMd6: mtrGridCellMd6,
    mtrGridCellMd7: mtrGridCellMd7,
    mtrGridCellMd8: mtrGridCellMd8,
    mtrGridCellMd9: mtrGridCellMd9,
    mtrGridCellMd10: mtrGridCellMd10,
    mtrGridCellMd11: mtrGridCellMd11,
    mtrGridCellMd12: mtrGridCellMd12,
    mtrGridCellLgHide: mtrGridCellLgHide,
    mtrGridCellLg1: mtrGridCellLg1,
    mtrGridCellLg2: mtrGridCellLg2,
    mtrGridCellLg3: mtrGridCellLg3,
    mtrGridCellLg4: mtrGridCellLg4,
    mtrGridCellLg5: mtrGridCellLg5,
    mtrGridCellLg6: mtrGridCellLg6,
    mtrGridCellLg7: mtrGridCellLg7,
    mtrGridCellLg8: mtrGridCellLg8,
    mtrGridCellLg9: mtrGridCellLg9,
    mtrGridCellLg10: mtrGridCellLg10,
    mtrGridCellLg11: mtrGridCellLg11,
    mtrGridCellLg12: mtrGridCellLg12,
    mtrGridCellXlHide: mtrGridCellXlHide,
    mtrGridCellXl1: mtrGridCellXl1,
    mtrGridCellXl2: mtrGridCellXl2,
    mtrGridCellXl3: mtrGridCellXl3,
    mtrGridCellXl4: mtrGridCellXl4,
    mtrGridCellXl5: mtrGridCellXl5,
    mtrGridCellXl6: mtrGridCellXl6,
    mtrGridCellXl7: mtrGridCellXl7,
    mtrGridCellXl8: mtrGridCellXl8,
    mtrGridCellXl9: mtrGridCellXl9,
    mtrGridCellXl10: mtrGridCellXl10,
    mtrGridCellXl11: mtrGridCellXl11,
    mtrGridCellXl12: mtrGridCellXl12,
    mtrGridCondensed: mtrGridCondensed$1,
    mtrGridCollapsed: mtrGridCollapsed$1,
    default: LayoutGrid_module
});

var numColumns = 12;
/**
 * A LayoutGrid allows components to be organized in a grid. Grids contain
 * Rows, which contain Cells, which may contain any content.
 */
var LayoutGrid = /** @class */ (function (_super) {
    __extends(LayoutGrid, _super);
    function LayoutGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutGrid.prototype.render = function () {
        var _a;
        var _b = this.props, padding = _b.padding, cellPadding = _b.cellPadding, children = _b.children, style = _b.style;
        var className = classnames(mtrGrid, (_a = {},
            _a[mtrGridCondensed$1] = this.props.condensed,
            _a[mtrGridCollapsed$1] = this.props.collapsed,
            _a), this.props.className);
        return PaddedContainer({
            className: className,
            padding: padding,
            cellPadding: cellPadding,
            children: children,
            style: style
        });
    };
    LayoutGrid.Container = LayoutGridContainer;
    LayoutGrid.Row = LayoutGridRow;
    LayoutGrid.Cell = LayoutGridCell;
    return LayoutGrid;
}(Component));
/**
 * A container that will constrain the width of contained rows.
 */
function LayoutGridContainer(props) {
    var children = props.children, padding = props.padding, className = props.className, cellPadding = props.cellPadding;
    return PaddedContainer({
        className: classnames(mtrGridContainer, className),
        allowTextChildren: true,
        children: children,
        padding: padding,
        cellPadding: cellPadding
    });
}
function PaddedContainer(props) {
    var allowTextChildren = props.allowTextChildren, padding = props.padding, style = props.style, children = props.children, cellPadding = props.cellPadding;
    var className = classnames(props.className, getPaddingClass(padding));
    var content = Children.map(children, function (child, index) {
        if (!child) {
            return;
        }
        else if (typeof child === 'string' || typeof child === 'number') {
            if (allowTextChildren) {
                return child;
            }
            return;
        }
        else {
            return cloneElement(child, {
                key: String(index),
                cellPadding: child.props.cellPadding || cellPadding
            });
        }
    });
    return (createElement("div", { className: className, style: style }, content));
}
/**
 * A row in a layout grid
 */
function LayoutGridRow(props) {
    var _a;
    var children = props.children, padding = props.padding, cellPadding = props.cellPadding, style = props.style;
    var columns = 0;
    var content = Children.map(children, function (child, index) {
        if (!child) {
            return;
        }
        else if (typeof child === 'string' || typeof child === 'number') {
            throw new Error('A row may only contain Cells');
        }
        else if (index > 11) {
            throw new Error("A row may not contain more than " + numColumns + " Cells");
        }
        else if (columns + Number(child.props.columns || 0) > 12) {
            throw new Error("A row may not occupy more than " + numColumns + " columns");
        }
        else {
            columns += Number(child.props.columns || 0);
            return cloneElement(child, {
                key: String(index),
                padding: child.props.padding || cellPadding
            });
        }
    });
    var className = classnames(mtrGridRow$1, props.className, getPaddingClass(padding), (_a = {},
        _a[mtrGridRowNowrap] = props.nowrap,
        _a[mtrGridRowStacked] = props.stacked,
        _a[mtrGridRowCenter] = props.center,
        _a));
    return (createElement("div", { className: className, style: style }, content));
}
function LayoutGridCell(props) {
    var style = props.style, padding = props.padding, children = props.children;
    var className = classnames.apply(void 0, [mtrGridCell$1].concat(getCellClass(props), [props.className,
        getPaddingClass(padding)]));
    return (createElement("div", { className: className, style: style }, children));
}
function isWidthCellProps(props) {
    return props && props.width != null;
}
function isColumnCellProps(props) {
    if (!props) {
        return false;
    }
    var colProps = props;
    return (colProps.columns != null ||
        colProps.columnsXs != null ||
        colProps.columnsSm != null ||
        colProps.columnsMd != null ||
        colProps.columnsLg != null ||
        colProps.columnsXl != null);
}
function getCellClass(props) {
    var classes = [];
    if (isWidthCellProps(props)) {
        classes.push("mtrGridCellW" + props.width);
    }
    else if (isColumnCellProps(props)) {
        classes.push("mtrGridCell" + props.columns);
        classes.push.apply(classes, ['Xs', 'Sm', 'Md', 'Lg', 'Xl']
            .filter(function (size) {
            return props["columns" + size] != null;
        })
            .map(function (size) {
            var cols = props["columns" + size];
            return "mtrGridCell" + size + (cols === 'hide' ? 'Hide' : cols);
        }));
    }
    else {
        classes.push("mtrGridCellFill");
    }
    return classes.map(function (className) { return styles[className]; });
}

var subtext$2 = "subtext";
var mtrMenu = "mtr-menu";
var mtrMenuLined = "mtr-menu--lined";
var mtrMenuItem = "mtr-menu__item";
var mtrMenuTitle = "mtr-menu__title";
var mtrMenuItemActive = "mtr-menu__item--active";
var mtrMenuIcon = "mtr-menu__icon";
var mtrMenuInfo = "mtr-menu__info";
var mtrMenuStatus = "mtr-menu__status";
var mtrMenuStatusSuccess = "mtr-menu__status--success";
var mtrMenuStatusWarning = "mtr-menu__status--warning";
var mtrMenuStatusDanger = "mtr-menu__status--danger";

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgComponent$2 = function (props) {
  return React__default.createElement("svg", _extends$2({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M24 4C12.95 4 4 12.95 4 24c0 11.04 8.95 20 20 20 11.04 0 20-8.96 20-20 0-11.05-8.96-20-20-20zm-4 30L10 24l2.83-2.83L20 28.34l15.17-15.17L38 16 20 34z"
  }));
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgComponent$3 = function (props) {
  return React__default.createElement("svg", _extends$3({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M24 4C12.96 4 4 12.95 4 24s8.96 20 20 20 20-8.95 20-20S35.04 4 24 4zm2 30h-4v-4h4v4zm0-8h-4V14h4v12z"
  }));
};

var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function (event) {
            var index = Number(event.currentTarget.getAttribute('data-item-id'));
            var item = Children.toArray(_this.props.children)[index];
            if (!item || typeof item === 'string' || typeof item === 'number') {
                return;
            }
            if (_this.props.highlightActiveItem || _this.props.defaultItem) {
                _this.setState({ activeItem: index });
            }
            if (_this.props.onItemChange) {
                _this.props.onItemChange(item.props.label);
            }
        };
        if (props.defaultItem) {
            Children.forEach(props.children, function (child, index) {
                if (typeof child !== 'string' &&
                    typeof child !== 'number' &&
                    child &&
                    child.props &&
                    child.props.label === props.defaultItem) {
                    _this.state = { activeItem: index };
                }
            });
        }
        else if (props.highlightActiveItem) {
            // If no defaultItem value was provided, select the first item by
            // default
            _this.state = { activeItem: 0 };
        }
        else {
            _this.state = { activeItem: null };
        }
        return _this;
    }
    Menu.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, lined = _b.lined, children = _b.children, title = _b.title, style = _b.style;
        var className = classnames(mtrMenu, (_a = {},
            _a[mtrMenuLined] = lined,
            _a), this.props.className);
        return (createElement("div", { className: className, style: style },
            title && (createElement("div", { className: mtrMenuTitle },
                createElement(Heading, { size: "xs", bold: true }, title))),
            Children.map(children, function (child, index) {
                if (typeof child === 'string' || typeof child === 'number') {
                    return;
                }
                else {
                    return cloneElement(child, {
                        key: String(index),
                        index: index,
                        onClick: _this.handleSelect,
                        isActive: index === _this.state.activeItem
                    });
                }
            })));
    };
    Menu.Item = MenuItem;
    return Menu;
}(Component));
function MenuItem(props) {
    var index = props.index, icon$$1 = props.icon, label = props.label, subtext = props.subtext, onClick = props.onClick, status = props.status, style = props.style, info = props.info;
    var statusClass = getMenuItemStatusClass(props);
    var danger = status === 'warning' || status === 'danger';
    return (createElement("div", { "data-item-id": index, onClick: onClick, className: getMenuItemClasses(props), style: style },
        icon$$1 && createElement("div", { className: mtrMenuIcon }, icon$$1),
        createElement("div", null,
            createElement(Heading, { size: "sm" }, label),
            subtext && createElement("p", { className: subtext$2 }, subtext)),
        info && createElement("div", { className: mtrMenuInfo }, info),
        statusClass && (createElement("div", { className: classnames(mtrMenuStatus, statusClass) }, danger ? createElement(SvgComponent$3, null) : createElement(SvgComponent$2, null)))));
}
function getMenuItemClasses(props) {
    var _a;
    return classnames(mtrMenuItem, (_a = {},
        _a[mtrMenuItemActive] = props.isActive,
        _a), props.className);
}
function getMenuItemStatusClass(props) {
    var icon$$1 = props.icon, status = props.status;
    return (icon$$1 &&
        status &&
        (status === 'warning'
            ? mtrMenuStatusWarning
            : status === 'danger'
                ? mtrMenuStatusDanger
                : status === 'success' ? mtrMenuStatusSuccess : undefined));
}

var mtrLoader = "mtr-loader";
var mtrLoaderSm = "mtr-loader--sm";
var mtrLoaderLg = "mtr-loader--lg";

/**
 * A Loader lets a user take an action or indicate something.
 */
function Loader(props) {
    var size = props.size, _a = props.active, active = _a === void 0 ? true : _a;
    var className = classnames(mtrLoader, size === 'lg' && mtrLoaderLg, size === 'sm' && mtrLoaderSm, props.className);
    return active ? createElement("div", { className: className, style: props.style }) : null;
}

var mtrModalOverlay = "mtr-modal__overlay";
var mtrModal = "mtr-modal";
var mtrModalActive = "mtr-modal--active";
var mtrModalClosing = "mtr-modal--closing";
var mtrModalSm = "mtr-modal--sm";
var mtrModalMd = "mtr-modal--md";
var mtrModalLg = "mtr-modal--lg";
var mtrModalFullscreen = "mtr-modal--fullscreen";
var mtrModalTitle = "mtr-modal__title";
var mtrModalTitleText = "mtr-modal__title-text";
var mtrModalClose = "mtr-modal__close";
var mtrModalBody = "mtr-modal__body";
var mtrModalFooter = "mtr-modal__footer";
var mtrModalFooterButtons = "mtr-modal__footer__buttons";
var mtrModalOverlayLeft = "mtr-modal__overlay--left";
var mtrModalOverlayRight = "mtr-modal__overlay--right";

/**
 * A modal component based on react-modal
 */
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Call this to properly hide your application from screenreaders and other
     * assistive technologies while the modal is open. This method may be called
     * at the application level during initialization or the `appElement`
     * property may be specified on all created modals.
     */
    Modal.setAppElement = function (appElement) {
        setAppElement(appElement);
    };
    Modal.prototype.render = function () {
        var _a;
        var props = this.props;
        var className = classnames(mtrModal, getSizeClass$4(this.props), props.className);
        var overlayClassName = classnames(mtrModalOverlay, (_a = {},
            _a[mtrModalOverlayLeft] = props.attach === 'left',
            _a[mtrModalOverlayRight] = props.attach === 'right',
            _a), props.overlayClassName);
        var _b = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _b === void 0 ? false : _b, _c = props.shouldCloseOnEscape, shouldCloseOnEscape = _c === void 0 ? false : _c;
        var modalProps = {
            isOpen: props.open,
            onRequestClose: props.shouldClose,
            appElement: props.appElement,
            className: {
                base: className,
                afterOpen: mtrModalActive,
                beforeClose: mtrModalClosing
            },
            overlayClassName: {
                base: overlayClassName,
                afterOpen: mtrModalActive,
                beforeClose: mtrModalClosing
            },
            closeTimeoutMS: 60,
            shouldCloseOnEsc: shouldCloseOnEscape,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            style: props.style
        };
        if (!props.appElement) {
            modalProps.ariaHideApp = false;
        }
        return (createElement(ReactModal, __assign({}, modalProps),
            this.renderTitle(),
            createElement("div", { className: mtrModalBody }, props.children),
            this.renderFooter()));
    };
    Modal.prototype.renderTitle = function () {
        var _a = this.props, title = _a.title, showClose = _a.showClose, shouldClose = _a.shouldClose;
        // For consistency with current usage, the showClose option defaults to
        // true if the title is a simple string, and to false if it's a custom
        // component.
        var shouldShowClose = typeof title === 'string'
            ? showClose == null
                ? true
                : showClose
            : showClose == null
                ? false
                : showClose;
        return (createElement("div", { className: mtrModalTitle },
            typeof title === 'string' ? (createElement("div", { className: mtrModalTitleText },
                createElement(Heading, { size: "xl" }, title))) : (title),
            shouldShowClose ? (createElement("button", { className: mtrModalClose, onClick: shouldClose },
                createElement(SvgComponent$1, null))) : (undefined)));
    };
    Modal.prototype.renderFooter = function () {
        var footer = this.props.footer;
        if (!footer) {
            return;
        }
        return (createElement("div", { className: mtrModalFooter }, isModalFooter(footer) ? (createElement("div", { className: mtrModalFooterButtons },
            footer.secondary ? (createElement(Button, { label: footer.secondary.label, onClick: footer.secondary.action, buttonType: "secondary", outline: true })) : (undefined),
            footer.primary ? (createElement(Button, { label: footer.primary.label, onClick: footer.primary.action })) : (undefined))) : (footer)));
    };
    return Modal;
}(Component));
function getSizeClass$4(props) {
    switch (props.size) {
        case 'sm':
            return mtrModalSm;
        case 'lg':
            return mtrModalLg;
        case 'fullscreen':
            return mtrModalFullscreen;
        default:
            return mtrModalMd;
    }
}
// tslint:disable-next-line:no-any
function isModalFooter(value) {
    return (value &&
        typeof value !== 'string' &&
        (value.primary != null || value.secondary != null));
}
// tslint:disable-next-line:no-any

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgComponent$4 = function (props) {
  return React__default.createElement("svg", _extends$4({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M24 9C14 9 5.46 15.22 2 24c3.46 8.78 12 15 22 15 10.01 0 18.54-6.22 22-15-3.46-8.78-11.99-15-22-15zm0 25c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10zm0-16c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
  }));
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgComponent$5 = function (props) {
  return React__default.createElement("svg", _extends$5({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M24 14c5.52 0 10 4.48 10 10 0 1.29-.26 2.52-.71 3.65l5.85 5.85c3.02-2.52 5.4-5.78 6.87-9.5-3.47-8.78-12-15-22.01-15-2.8 0-5.48.5-7.97 1.4l4.32 4.31c1.13-.44 2.36-.71 3.65-.71zM4 8.55l4.56 4.56.91.91C6.17 16.6 3.56 20.03 2 24c3.46 8.78 12 15 22 15 3.1 0 6.06-.6 8.77-1.69l.85.85L39.45 44 42 41.46 6.55 6 4 8.55zM15.06 19.6l3.09 3.09c-.09.43-.15.86-.15 1.31 0 3.31 2.69 6 6 6 .45 0 .88-.06 1.3-.15l3.09 3.09C27.06 33.6 25.58 34 24 34c-5.52 0-10-4.48-10-10 0-1.58.4-3.06 1.06-4.4zm8.61-1.57l6.3 6.3L30 24c0-3.31-2.69-6-6-6l-.33.03z"
  }));
};

var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            _this.setState({ showPassword: !_this.state.showPassword });
        };
        _this.state = { showPassword: false };
        return _this;
    }
    Password.prototype.render = function () {
        var wrapped = isWrapped(this.props);
        var showPassword = this.state.showPassword;
        var _a = this.props, className = _a.className, label = _a.label, aside = _a.aside, style = _a.style, subtext = _a.subtext, inputProps = __rest(_a, ["className", "label", "aside", "style", "subtext"]);
        var input = (createElement(Form.Group, { className: wrapped ? undefined : className, style: wrapped ? undefined : style },
            createElement(Input, __assign({}, inputProps, { type: showPassword ? 'text' : 'password' })),
            createElement(Button, { icon: showPassword ? createElement(SvgComponent$5, null) : createElement(SvgComponent$4, null), buttonType: "secondary", size: this.props.size, onClick: this.handleClick })));
        return addLabel(addSubtext(input, this.props), this.props);
    };
    return Password;
}(Component));

var mtrPopover = "mtr-popover";
var mtrPopoverActive = "mtr-popover--active";
var mtrPopoverHidden = "mtr-popover--hidden";

/**
 * Wraps a callback, returning a function which fires at most once per set interval.
 *
 * @param callback Callback to wrap
 * @param delay Number of milliseconds to wait before allowing the original callback to be called again
 * @return Throttled function
 */
// tslint:disable-next-line:no-any
function throttle(callback, delay) {
    var ran;
    return function () {
        if (ran) {
            return;
        }
        ran = true;
        callback.apply(this, arguments);
        guaranteeMinimumTimeout(function () {
            ran = null;
        }, delay);
    };
}
function guaranteeMinimumTimeout(
// tslint:disable-next-line:no-any
callback, delay) {
    var startTime = Date.now();
    var timerId;
    function timeoutHandler() {
        var delta = Date.now() - startTime;
        if (delay == null || delta >= delay) {
            callback();
        }
        else {
            // Cast setTimeout return value to fix TypeScript parsing bug.  Without it,
            // it thinks we are using the Node version of setTimeout.
            // Revisit this with the next TypeScript update.
            // Set another timer for the amount of time that we came up short.
            // tslint:disable-next-line:no-any
            timerId = setTimeout(timeoutHandler, delay - delta);
        }
    }
    timerId = setTimeout(timeoutHandler, delay);
    return function () {
        if (timerId != null) {
            clearTimeout(timerId);
            timerId = null;
        }
    };
}

var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePopoverVisible = function () {
            // Add the listener in a timeout so it won't handle a mouse click that
            // initially opened the popover
            setTimeout(function () {
                window.addEventListener('click', _this.handleClick);
            });
        };
        _this.handlePopoverHidden = function () {
            window.removeEventListener('click', _this.handleClick);
        };
        _this.setRef = function (node) {
            _this.popoverRoot = node;
        };
        _this.handleClick = function (event) {
            if (!_this.popoverRoot.contains(event.target)) {
                _this.props.shouldClose();
            }
        };
        var anchor = props.anchor, container = props.container;
        _this.state = {
            containerElement: (container &&
                (typeof container === 'function' ? container() : container)) ||
                getContainerElement(anchor)
        };
        _this.throttledUpdatePosition = throttle(_this.updatePosition, 166);
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.throttledUpdatePosition);
        // If the component is initially open when mounted, ensure listeners are
        // added
        if (this.props.open) {
            this.handlePopoverVisible();
        }
    };
    Popover.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.open) {
            // Update the position any time props are updated and the popover is open
            // because the popover may be updated or moved without first being
            // closed.
            this.updatePosition();
            if (!prevProps.open) {
                // The popover was just opened
                this.handlePopoverVisible();
                // Once the popover has been intially rendered, set its rendered flag to
                // true
                this.setState({ rendered: true });
            }
        }
        else if (prevProps.open && !this.props.open) {
            // The popover was just closed
            this.handlePopoverHidden();
        }
    };
    Popover.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.throttledUpdatePosition);
        this.handlePopoverHidden();
    };
    Popover.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.container !== this.props.container ||
            (!newProps.container && newProps.anchor !== this.props.anchor)) {
            var container = newProps.container, anchor = newProps.anchor;
            this.setState({
                containerElement: (container &&
                    (typeof container === 'function' ? container() : container)) ||
                    getContainerElement(anchor)
            });
        }
        // When the component is first being made visible, set its rendered flag to
        // false
        if (newProps.open && !this.props.open) {
            this.setState({ rendered: false });
        }
    };
    Popover.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, open = _b.open, style = _b.style;
        var className = classnames(mtrPopover, (_a = {},
            _a[mtrPopoverActive] = Boolean(open && this.state.rendered),
            _a[this.props.className || ''] = Boolean(open && this.props.className),
            _a[mtrPopoverHidden] = !open,
            _a));
        return createPortal(createElement("div", { className: className, ref: this.setRef, style: style }, children), this.state.containerElement);
    };
    /**
     * Calculate the popover's offset within its offset parent.
     */
    Popover.prototype.calculatePopoverBounds = function () {
        if (!this.popoverRoot) {
            return { top: 0, left: 0, width: 0, height: 0 };
        }
        var _a = this.popoverRoot.getBoundingClientRect(), width = _a.width, height = _a.height;
        var top = calculateDimension(0, height, this.props.origin && this.props.origin.vertical);
        var left = calculateDimension(0, width, this.props.origin && this.props.origin.horizontal);
        return { top: top, left: left, width: width, height: height };
    };
    /**
     * Calculate the anchor's position within its offset parent.
     */
    Popover.prototype.calculateAnchorPosition = function (containerElement, anchor) {
        if (typeof anchor === 'function') {
            return this.calculateAnchorPosition(containerElement, anchor());
        }
        if (anchor && isPosition(anchor)) {
            return anchor;
        }
        var _a = anchor
            ? anchor.getBoundingClientRect()
            : { top: 0, left: 0, width: 0, height: 0 }, anchorTop = _a.top, anchorLeft = _a.left, width = _a.width, height = _a.height;
        var _b = containerElement.getBoundingClientRect(), containerTop = _b.top, containerLeft = _b.left;
        var relativeTop = Math.max(anchorTop - containerTop, 0);
        var relativeLeft = Math.max(anchorLeft - containerLeft, 0);
        var top = calculateDimension(relativeTop, height, this.props.position && this.props.position.vertical);
        var left = calculateDimension(relativeLeft, width, this.props.position && this.props.position.horizontal);
        return { top: top, left: left };
    };
    /**
     * Update the popover's position after it's been rendered or the viewport
     * size has changed.
     */
    Popover.prototype.updatePosition = function () {
        if (!this.popoverRoot) {
            return;
        }
        var _a = this.calculateAnchorPosition(this.state.containerElement, this.props.anchor), anchorTop = _a.top, anchorLeft = _a.left;
        var _b = this.calculatePopoverBounds(), offsetTop = _b.top, offsetLeft = _b.left, width = _b.width, height = _b.height;
        var top = Math.max(Math.min(anchorTop - offsetTop, document.body.scrollHeight - height), 0);
        var left = Math.max(Math.min(anchorLeft - offsetLeft, document.body.scrollWidth - width), 0);
        this.popoverRoot.style.top = top ? top + "px" : '0';
        this.popoverRoot.style.left = left ? left + "px" : '0';
    };
    return Popover;
}(Component));
function isPosition(anchor) {
    var _a = anchor, top = _a.top, left = _a.left;
    return typeof top === 'number' && typeof left === 'number';
}
function getContainerElement(anchor) {
    if (typeof anchor === 'function') {
        return getContainerElement(anchor());
    }
    else if (!anchor || isPosition(anchor)) {
        return document.body;
    }
    else {
        return anchor.ownerDocument.body;
    }
}
function calculateDimension(base, dimension, orientation) {
    if (typeof orientation === 'number') {
        return base + orientation;
    }
    switch (orientation) {
        case 'center':
            return base + dimension / 2;
        case 'bottom':
        case 'right':
            return base + dimension;
        default:
            return base;
    }
}

var mtrSidenavTitle = "mtr-sidenav__title";
var mtrSidenavItem = "mtr-sidenav__item";
var mtrSidenavItemActive = "mtr-sidenav__item--active";

function getElement(selector) {
    return (selector && document.querySelector(selector)) || window;
}
/**
 * Provides menu based navigation and scroll tracking
 */
var SideNav = /** @class */ (function (_super) {
    __extends(SideNav, _super);
    function SideNav(props) {
        var _this = _super.call(this, props) || this;
        _this.menu = null;
        _this.handleSelect = function (event) {
            var itemId = event.currentTarget.getAttribute('data-item-id');
            _this.setState({
                activeItem: itemId
            });
        };
        _this.handleScroll = function () {
            function isAboveBottom(element) {
                var boundingClientRect = element && element.getBoundingClientRect();
                if (!boundingClientRect) {
                    return false;
                }
                var parent = element.parentElement;
                var parentRect = parent.getBoundingClientRect();
                if (parentRect.bottom < 0 || parentRect.top > window.innerHeight) {
                    return false;
                }
                var bottom = parentRect.bottom;
                if (boundingClientRect.top > bottom) {
                    return false;
                }
                return true;
            }
            var lastAboveItem;
            if (_this.menu) {
                var items = Array.from(_this.menu.querySelectorAll('li a'));
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    var ref = item.getAttribute('href');
                    var target = ref ? document.body.querySelector(ref) : undefined;
                    if (!target) {
                        continue;
                    }
                    if (isAboveBottom(target)) {
                        lastAboveItem = item;
                    }
                    else {
                        break;
                    }
                }
                if (lastAboveItem) {
                    _this.setState({
                        activeItem: lastAboveItem.getAttribute('data-item-id')
                    });
                }
            }
        };
        // Select the first child by default
        var children = Children.toArray(props.children);
        if (children.length > 0) {
            var child = children[0];
            _this.state = {
                activeItem: child.props.target || idFromLabel(child.props.label),
                observedElement: null
            };
        }
        else {
            _this.state = { activeItem: null, observedElement: null };
        }
        return _this;
    }
    SideNav.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.target !== this.props.target) {
            if (this.state.observedElement) {
                this.state.observedElement.removeEventListener('scroll', this.handleScroll);
            }
            var observedElement = getElement(newProps.target);
            observedElement.addEventListener('scroll', this.handleScroll);
            this.setState({ observedElement: observedElement });
        }
    };
    SideNav.prototype.componentDidMount = function () {
        var observedElement = getElement(this.props.target);
        observedElement.addEventListener('scroll', this.handleScroll);
        this.setState({ observedElement: observedElement });
    };
    SideNav.prototype.componentWillUnmount = function () {
        if (this.state.observedElement) {
            this.state.observedElement.removeEventListener('scroll', this.handleScroll);
        }
    };
    SideNav.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, title = _a.title, className = _a.className, style = _a.style;
        var titleClassName = classnames(mtrSidenavTitle, mtrHeadingXxs);
        return (createElement("nav", { className: className, style: style },
            createElement("h3", { className: titleClassName }, title),
            createElement("ul", { ref: function (menu) { return (_this.menu = menu); } }, Children.map(children, function (child, index) {
                var getProps = function (props) {
                    var key = props.key, target = props.target, label = props.label;
                    var id = target || idFromLabel(label);
                    return {
                        key: key || String(index),
                        onClick: _this.handleSelect,
                        isActive: id === _this.state.activeItem
                    };
                };
                if (typeof child === 'string' || typeof child === 'number') {
                    return ("" + child)
                        .trim()
                        .split(/\s+/)
                        .map(function (label, subIndex) { return (createElement(SideNavItem, __assign({ label: label }, getProps({ label: label, key: index + "-" + subIndex })))); });
                }
                else if (child.type === SideNavItem) {
                    return cloneElement(child, getProps(child.props));
                }
                else if (typeof child.props.children === 'string') {
                    var label = child.props.children.trim();
                    return createElement(SideNavItem, __assign({ label: label }, getProps({ label: label })));
                }
                return null;
            }))));
    };
    SideNav.Item = SideNavItem;
    return SideNav;
}(Component));
function SideNavItem(props) {
    var _a;
    var label = props.label, target = props.target, isActive = props.isActive, onClick = props.onClick, style = props.style;
    var href = target || idFromLabel(label);
    var className = classnames(mtrSidenavItem, (_a = {},
        _a[mtrSidenavItemActive] = isActive,
        _a), props.className);
    return (createElement("li", null,
        createElement("a", { className: className, style: style, onClick: onClick, "data-item-id": href, href: "#" + href }, label)));
}
function idFromLabel(label) {
    return label.replace(/\s+/g, '-').toLowerCase();
}

var reactCompoundSlider = require('react-compound-slider');
var Slider = reactCompoundSlider.default;

var mtrSliderWrapper = "mtr-slider__wrapper";
var mtrSlider = "mtr-slider";
var mtrSliderRail = "mtr-slider__rail";
var mtrSliderTracks = "mtr-slider__tracks";
var mtrSliderTrack = "mtr-slider__track";
var mtrSliderHandles = "mtr-slider__handles";
var mtrSliderHandle = "mtr-slider__handle";
var mtrSliderHandleLabel = "mtr-slider__handle-label";
var mtrSliderTick = "mtr-slider__tick";
var mtrSliderTickMark = "mtr-slider__tick-mark";
var mtrSliderTickLabel = "mtr-slider__tick-label";
var mtrSliderTicks = "mtr-slider__ticks";
var mtrSliderTicksEdges = "mtr-slider__ticks--edges";
var mtrSliderValue = "mtr-slider--value";
var mtrSliderTickMarks = "mtr-slider--tick-marks";
var mtrSliderValueAndTickMarks = "mtr-slider--value-and-tick-marks";
var mtrSliderTickLabels = "mtr-slider--tick-labels";
var mtrSliderValueAndTickLabels = "mtr-slider--value-and-tick-labels";
var mtrSliderTickMarksAndTickLabels = "mtr-slider--tick-marks-and-tick-labels";
var mtrSliderValueAndTickMarksAndTickLabels = "mtr-slider--value-and-tick-marks-and-tick-labels";

var defaultRange = [0, 100];
function Slider$1(props) {
    var _a = props.range, range = _a === void 0 ? defaultRange : _a, containTickLabels = props.containTickLabels, _b = props.showTickLabels, showTickLabels = _b === void 0 ? true : _b, _c = props.showValueLabels, showValueLabels = _c === void 0 ? true : _c, _d = props.classNames, clsNames = _d === void 0 ? {} : _d;
    var tickValues = getTickValues(props);
    var wrapped = isWrapped(props);
    var rangeValue = range[1] - range[0];
    var _e = props.value, value = _e === void 0 ? [range[0] + rangeValue / 2] : _e;
    var containTicks = containTickLabels &&
        tickValues[0] === range[0] &&
        tickValues[tickValues.length - 1] === range[1];
    var sliderClass = classnames(mtrSlider, !wrapped && props.className, getSliderClass(props));
    var slider = (createElement("div", { className: mtrSliderWrapper },
        createElement(Slider, { className: sliderClass, domain: range, mode: 3, step: Math.ceil(rangeValue / 100), values: value, onUpdate: props.onChange, rootStyle: wrapped ? undefined : props.style },
            createElement(Slider.Rail, null, function (railProps) { return (createElement("div", __assign({ className: classnames(mtrSliderRail, clsNames.rail) }, railProps.getRailProps()))); }),
            createElement(Slider.Handles, null, function (handleProps) { return (createElement("div", { className: mtrSliderHandles }, handleProps.handles.map(function (handle) { return (createElement(Handle, { key: handle.id, className: classnames(mtrSliderHandle, clsNames.handle), labelClassName: classnames(mtrSliderHandleLabel, clsNames.handleLabel), handle: handle, getHandleProps: handleProps.getHandleProps, showLabel: showValueLabels })); }))); }),
            createElement(Slider.Tracks, { right: false, left: value.length <= 1 }, function (tracksProps) { return (createElement("div", { className: mtrSliderTracks }, tracksProps.tracks.map(function (track) { return (createElement(Track, { key: track.id, className: classnames(mtrSliderTrack, clsNames.track), source: track.source, target: track.target, getTrackProps: tracksProps.getTrackProps })); }))); }),
            createElement(Slider.Ticks, { values: tickValues }, function (ticksProps) {
                var _a;
                return (createElement("div", { className: classnames(mtrSliderTicks, (_a = {},
                        _a[mtrSliderTicksEdges] = containTicks,
                        _a)) }, ticksProps.ticks.map(function (tick) { return (createElement(Tick, { key: tick.id, tick: tick, count: ticksProps.ticks.length, className: classnames(mtrSliderTick, clsNames.tick), markClassName: classnames(mtrSliderTickMark, clsNames.tickMark), labelClassName: classnames(mtrSliderTickLabel, clsNames.tickLabel), showMark: props.showTickMarks, showLabel: showTickLabels })); })));
            }))));
    return addLabel(addSubtext(slider, props), props);
}
/**
 * Render a value/drag handle
 */
function Handle(props) {
    return (createElement("div", __assign({ className: props.className, style: { left: props.handle.percent + "%" } }, props.getHandleProps(props.handle.id)), props.showLabel ? (createElement("div", { className: props.labelClassName }, props.handle.value)) : (undefined)));
}
/**
 * Render a track within a rail
 */
function Track(props) {
    var source = props.source, target = props.target, className = props.className;
    return (createElement("div", __assign({ className: className, style: {
            left: source.percent + "%",
            width: target.percent - source.percent + "%"
        } }, props.getTrackProps())));
}
/**
 * Render a tick mark and label
 */
function Tick(props) {
    return (createElement("div", { className: props.className, style: { left: props.tick.percent + "%" } },
        props.showMark ? createElement("div", { className: props.markClassName }) : undefined,
        props.showLabel ? (createElement("div", { className: props.labelClassName },
            " ",
            props.tick.value,
            " ")) : (undefined)));
}
function getSliderClass(props) {
    switch (getSliderClassKey(props)) {
        case 1:
            return mtrSliderValue;
        case 2:
            return mtrSliderTickMarks;
        case 3:
            return mtrSliderValueAndTickMarks;
        case 4:
            return mtrSliderTickLabels;
        case 5:
            return mtrSliderValueAndTickLabels;
        case 6:
            return mtrSliderTickMarksAndTickLabels;
        case 7:
            return mtrSliderValueAndTickMarksAndTickLabels;
        default:
            return;
    }
}
function getSliderClassKey(props) {
    var _a = props.showValueLabels, showValueLabels = _a === void 0 ? true : _a, _b = props.showTickMarks, showTickMarks = _b === void 0 ? false : _b, _c = props.showTickLabels, showTickLabels = _c === void 0 ? true : _c;
    var valueLabels = showValueLabels ? 1 : 0;
    var tickMarks = showTickMarks ? 2 : 0;
    var tickLabels = showTickLabels ? 4 : 0;
    return valueLabels + tickMarks + tickLabels;
}
/**
 * Get the list of tick values that should be rendered based on the Slider's
 * props.
 *
 * Unlike the default react-compount-slider algorithm, this function always
 * honors tickCount. For example, if the tickCount is 2, there will always be 2
 * ticks, regardless of the range.
 */
function getTickValues(props) {
    var _a = props.range, range = _a === void 0 ? defaultRange : _a, showTickMarks = props.showTickMarks, _b = props.showTickLabels, showTickLabels = _b === void 0 ? true : _b, _c = props.tickCount, tickCount = _c === void 0 ? 2 : _c, tickValues = props.tickValues;
    if (!showTickMarks && !showTickLabels) {
        return [];
    }
    if (tickValues) {
        return tickValues;
    }
    var tickVals = [];
    if (tickCount === 1) {
        tickVals.push(range[0] + (range[1] - range[0]) / 2);
    }
    else {
        tickVals.push(range[0]);
        var step = (range[1] - range[0]) / (tickCount - 1);
        for (var i = 0; i < tickCount - 1; i++) {
            tickVals.push(range[0] + step * (i + 1));
        }
    }
    return tickVals;
}

var mtrTabs = "mtr-tabs";
var mtrTabsTab = "mtr-tabs__tab";
var mtrTabsTabActive = "mtr-tabs__tab--active";
var mtrTabsLabel = "mtr-tabs__label";
var mtrTabsTabDisabled = "mtr-tabs__tab--disabled";

/**
 * A Tabs element
 */
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function (event) {
            if (_this.props.disabled) {
                return;
            }
            var name = event.currentTarget.getAttribute('data-tab-id');
            var tab = _this.getTab(name);
            if (!tab || tab.props.disabled) {
                return;
            }
            _this.setState({ activeTab: name });
            if (_this.props.onTabChange) {
                _this.props.onTabChange(name);
            }
        };
        if (props.defaultTab) {
            _this.state = { activeTab: props.defaultTab };
        }
        else {
            // If no defaultTab value was provided, select the first tab by
            // default
            var children = Children.toArray(props.children);
            if (children.length > 0) {
                var child = children[0];
                if (child.props) {
                    _this.state = { activeTab: child.props.label };
                }
            }
            else {
                _this.state = { activeTab: null };
            }
        }
        return _this;
    }
    Tabs.prototype.render = function () {
        var _this = this;
        var activeTab;
        var _a = this.props, className = _a.className, style = _a.style;
        return (createElement("div", { className: className, style: style },
            createElement("div", { className: mtrTabs }, Children.map(this.props.children, function (child, index) {
                if (typeof child === 'string' || typeof child === 'number') {
                    return;
                }
                else {
                    if (_this.state.activeTab &&
                        child.props.label === _this.state.activeTab) {
                        activeTab = child;
                    }
                    return cloneElement(child, {
                        key: String(index),
                        onClick: _this.handleSelect,
                        disabled: _this.props.disabled,
                        isActive: child.props.label === _this.state.activeTab
                    });
                }
            })),
            createElement("div", { className: activeTab && activeTab.props.className }, activeTab && activeTab.props.children)));
    };
    Tabs.prototype.getTab = function (label) {
        var children = Children.toArray(this.props.children);
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var child = children_1[_i];
            if (typeof child === 'string' || typeof child === 'number') {
                continue;
            }
            if (child.props && child.props.label === label) {
                return child;
            }
        }
        return;
    };
    Tabs.Tab = TabsTab;
    return Tabs;
}(Component));
function TabsTab(props) {
    var _a;
    var disabled = props.disabled, isActive = props.isActive, label = props.label, style = props.style;
    var className = classnames(mtrTabsTab, (_a = {},
        _a[mtrTabsTabActive] = isActive,
        _a[mtrTabsTabDisabled] = disabled,
        _a), props.className);
    return (createElement("div", { className: className, "data-tab-id": label, onClick: props.onClick, style: style },
        createElement("span", { className: mtrTabsLabel }, label)));
}

var mtrTable = "mtr-table";
var mtrTableEmptyCell = "mtr-table__empty-cell";
var mtrTableRow = "mtr-table__row";
var mtrTableRowInvalidWarning = "mtr-table-row-invalid-warning";
var mtrTableRowActionButton = "mtr-table-row-action-button";
var mtrTableRowInvalid = "mtr-table__row--invalid";
var mtrTableCell = "mtr-table-cell";
var mtrTableInvalidCell = "mtr-table-invalid-cell";
var mtrTableInputColumn = "mtr-table-input-column";
var mtrTableRowAction = "mtr-table__row--action";
var mtrTableRowControlling = "mtr-table__row--controlling";
var mtrTableField = "mtr-table-field";
var mtrTableFieldRight = "mtr-table-field__right";
var mtrTableFieldEmpty = "mtr-table-field__empty";
var mtrTableSelectedRow = "mtr-table__selected-row";
var mtrTableAddUnitRow = "mtr-table__add-unit-row";
var mtrTableEmptyRow = "mtr-table__empty-row";
var mtrTableDateCell = "mtr-table__date-cell";
var mtrTableCenterCellContent = "mtr-table__center-cell-content";
var mtrValidationPopover = "mtr-validation-popover";
var mtrTablePagination = "mtr-table-pagination";
var mtrTablePaginationPrevious = "mtr-table-pagination__previous";
var mtrTablePaginationNext = "mtr-table-pagination__next";
var mtrTablePaginationFormControls = "mtr-table-pagination__form-controls";
var mtrTableDndPreview = "mtr-table-dnd-preview";
var mtrTableDndPreviewDragging = "mtr-table-dnd-preview--dragging";
var mtrTableDndSource = "mtr-table-dnd-source";
var mtrTableDndSourceIcon = "mtr-table-dnd-source__icon";

var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.getSafePage = function (page) {
            return Math.min(Math.max(page, 0), _this.props.pages - 1);
        };
        _this.changePage = function (page) {
            page = _this.getSafePage(page);
            _this.setState({ page: page });
            if (_this.props.page !== page) {
                _this.props.onPageChange(page);
            }
        };
        _this.applyPage = function (event) {
            if (event) {
                event.preventDefault();
            }
            var page = _this.state.page;
            _this.changePage(!page && page !== 0 ? _this.props.page : page);
        };
        _this.state = {
            page: props.page
        };
        return _this;
    }
    Pagination.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ page: nextProps.page });
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var _a = this.props, 
        // Computed
        pages = _a.pages, 
        // Props
        page = _a.page, showPageSizeOptions = _a.showPageSizeOptions, pageSizeOptions = _a.pageSizeOptions, pageText = _a.pageText, ofText = _a.ofText, pageSize = _a.pageSize, previousText = _a.previousText, nextText = _a.nextText, showPageJump = _a.showPageJump, canPrevious = _a.canPrevious, canNext = _a.canNext, rowsText = _a.rowsText, onPageSizeChange = _a.onPageSizeChange, className = _a.className, anchor = _a.anchor;
        var classes = [mtrTablePagination];
        if (className) {
            classes.push(className);
        }
        var paginationDom = (createElement("div", { className: classes.join(' '), style: this.props.style },
            createElement("div", { className: mtrTablePaginationPrevious },
                createElement(Button, { size: "sm", onClick: function () {
                        if (!canPrevious) {
                            return;
                        }
                        _this.changePage(page - 1);
                    }, disabled: !canPrevious, label: previousText })),
            createElement("div", { className: mtrTablePaginationFormControls },
                createElement("span", null,
                    pageText,
                    " "),
                showPageJump ? (createElement(Input, { size: "sm", name: "page", onChange: function (e) {
                        var value = e.currentTarget.value;
                        var newPage = parseInt(value, 10) - 1 || 0;
                        _this.setState({ page: _this.getSafePage(newPage) });
                    }, value: String(this.state.page + 1), onBlur: this.applyPage, onKeyPress: function (e) {
                        if (e.which === 13 || e.keyCode === 13) {
                            _this.applyPage();
                        }
                    } })) : (createElement("span", null, page + 1)),
                ' ',
                ofText && (createElement("span", null,
                    ofText,
                    " ",
                    pages || 1)),
                showPageSizeOptions && (createElement(Select, { size: "sm", name: "pageSize", onChange: function (e) {
                        var newPageSize = e.currentTarget.value.split(' ')[0];
                        if (newPageSize !== String(pageSize)) {
                            onPageSizeChange(Number(newPageSize));
                        }
                    }, value: pageSize + " " + rowsText }, pageSizeOptions.map(function (option, i) { return (createElement(Select.Option, { key: i, value: option + " " + rowsText })); })))),
            createElement("div", { className: mtrTablePaginationNext },
                createElement(Button, { size: "sm", onClick: function () {
                        if (!canNext) {
                            return;
                        }
                        _this.changePage(page + 1);
                    }, disabled: !canNext, label: nextText }))));
        return anchor ? createPortal(paginationDom, anchor) : paginationDom;
    };
    return Pagination;
}(Component));

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgComponent$6 = function (props) {
  return React__default.createElement("svg", _extends$6({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z"
  }));
};

function pad(value, length, left) {
    if (left === void 0) { left = true; }
    var valueString = "" + value;
    while (valueString.length < length) {
        valueString = left ? "0" + valueString : valueString + "0";
    }
    return valueString;
}
/**
 * Prepends zeros to a number to achieve the specified length,
 * defaulting to 2
 */
function padLeft(value, length) {
    if (length === void 0) { length = 2; }
    return pad(value, length, true);
}
/** Formats currency, with commas, a dollar sign, and cents */
function formatCurrency(amount) {
    if (amount == null) {
        return amount;
    }
    var dollars = Math.floor(amount);
    var cents = padLeft(Math.round((amount - Math.floor(amount)) * 100));
    return "" + (dollars > 0 ? '$' : '') + addCommas(dollars) + "." + cents;
}
/**
 * Formats a percent value
 */
function formatPercent(amount) {
    return amount == null ? amount : amount + "%";
}
/** Adds commas to separate thousands, millions, etc. */
function addCommas(value) {
    var valueString = "" + value;
    var withCommas = '';
    for (var i = 0; i < valueString.length; i++) {
        if (i > 0 && i % 3 === 0) {
            withCommas = "," + withCommas;
        }
        withCommas = "" + valueString[valueString.length - 1 - i] + withCommas;
    }
    return withCommas;
}
// Scrollbar width could theoretically be null if we're doing server-side
// rendering
var scrollbarWidth;
function getScrollbarWidth() {
    if (typeof scrollbarWidth !== 'undefined') {
        return scrollbarWidth;
    }
    var content = document.createElement('p');
    content.style.width = '100%';
    content.style.height = '100px';
    var wrapper = document.createElement('div');
    wrapper.style.width = '100px';
    wrapper.style.height = '50px';
    wrapper.style.position = 'absolute';
    wrapper.appendChild(content);
    document.body.appendChild(wrapper);
    var initialWidth = content.offsetWidth;
    wrapper.style.overflow = 'scroll';
    var scrollWidth = content.offsetWidth;
    scrollbarWidth = initialWidth - scrollWidth;
    document.body.removeChild(wrapper);
    return scrollbarWidth;
}
/**
 * Return a debounced version of a callback function. The callback will be
 * called at most once every `delay` ms.
 */
function debounce(callback, delay) {
    if (delay === void 0) { delay = 100; }
    var timer;
    return function () {
        if (timer) {
            return;
        }
        timer = window.setTimeout(function () {
            callback();
            timer = undefined;
        }, delay);
    };
}

var STATUS_COLUMN_ID = 'rowStatus';
var ReactTable$1 = _ReactTable;
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.updateTableDom = debounce(function () {
            var node = findDOMNode(_this.tableRef.current);
            if (!node) {
                return;
            }
            var body = node.querySelector('.rt-tbody');
            var head = node.querySelector('.rt-thead');
            var foot = node.querySelector('.rt-tfoot');
            var table = node.querySelector('.rt-table');
            var scrollbarWidth = getScrollbarWidth();
            var pad = '0px';
            if (body && head && foot && table) {
                // Remove any manually specified widths so that the offsetWidths will be at
                // their natural values.
                body.style.width = '';
                head.style.width = '';
                foot.style.width = '';
                // If the body's content width is not the same as the body width, a
                // vertical scrollbar is visible
                if (body.offsetWidth !== body.clientWidth) {
                    pad = scrollbarWidth + "px";
                }
                // If the table contents are wider than the table itself, a horizontal
                // scrollbar will be visible
                if (body.offsetWidth > node.offsetWidth && !body.style.width) {
                    var width = body.offsetWidth + scrollbarWidth + "px";
                    body.style.width = width;
                    head.style.width = width;
                    foot.style.width = width;
                    // If the table needs to scroll horizontally, manually set overflow-x to
                    // 'scroll' so that scrollbars won't overlap content in IE.
                    table.style.overflowX = 'scroll';
                }
                else {
                    table.style.overflowX = 'auto';
                }
                head.style.paddingRight = pad;
                foot.style.paddingRight = pad;
            }
        }, 100);
        _this.paginationRef = null;
        _this.closePopover = function () {
            _this.updatePopoverState({
                tablePopoverOpen: false,
                tablePopoverAnchor: undefined,
                tablePopoverRowId: undefined
            });
        };
        _this.getTdProps = function (_state, rowInfo, column) {
            if (rowInfo === void 0) { rowInfo = {}; }
            if (column === void 0) { column = {}; }
            var className = mtrTableCell;
            var _a = rowInfo.original, original = _a === void 0 ? {} : _a;
            var _b = original.id, id = _b === void 0 ? '' : _b, errors = original.errors;
            var field = column.id || column.accessor || '';
            if (errors && errors[field]) {
                return {
                    className: className + " " + mtrTableInvalidCell,
                    onClick: function (event) {
                        event.stopPropagation();
                    },
                    onFocus: function (event) {
                        var currentTarget = event.currentTarget;
                        _this.updatePopoverState({
                            tablePopoverOpen: typeof errors[field] === 'string',
                            tablePopoverRowId: id,
                            tablePopoverAnchor: currentTarget,
                            tablePopoverContent: (createElement("div", { className: mtrValidationPopover }, errors[field])),
                            tablePopoverPosition: {
                                horizontal: column.popoverSide || 'right',
                                vertical: 'bottom'
                            },
                            tablePopoverOrigin: {
                                vertical: 'top',
                                horizontal: column.popoverSide || 'right'
                            }
                        });
                    },
                    onBlur: function (event) {
                        var popoverState = _this.props.popoverState || _this.state.popoverState;
                        // Only close the popover if it's associated with this cell
                        if (popoverState.tablePopoverRowId === id &&
                            popoverState.tablePopoverOpen &&
                            popoverState.tablePopoverAnchor === event.currentTarget) {
                            _this.closePopover();
                        }
                    }
                };
            }
            return {
                className: className
            };
        };
        _this.getTrProps = function () {
            // tslint:disable-next-line:no-any
            var args = [];
            for (
            // tslint:disable-next-line:no-any
            var _i = 0; 
            // tslint:disable-next-line:no-any
            _i < arguments.length; 
            // tslint:disable-next-line:no-any
            _i++) {
                // tslint:disable-next-line:no-any
                args[_i] = arguments[_i];
            }
            var _a;
            var rowInfo = args[1] || {};
            var getProps = _this.props.getTrProps;
            var originalProps = getProps ? getProps.apply(void 0, args) : {};
            var originalClassName = originalProps.className;
            var _b = rowInfo.original, original = _b === void 0 ? {} : _b;
            var _c = original.id, id = _c === void 0 ? '' : _c, errors = original.errors;
            var rowProps = {
                TrComponent: _this.props.TrComponent
            };
            if (id === '') {
                rowProps.className = classnames(originalClassName, mtrTableEmptyRow);
            }
            else {
                var _d = _this.props.popoverState || _this.state.popoverState, tablePopoverOpen = _d.tablePopoverOpen, tablePopoverRowId = _d.tablePopoverRowId;
                rowProps.className = classnames(originalClassName, _this.getRowClass(id, errors), (_a = {},
                    _a[mtrTableRowControlling] = tablePopoverOpen && tablePopoverRowId === id,
                    _a));
                if (original.isIncomplete) {
                    var originalOnBlur_1 = originalProps.onBlur;
                    rowProps.onBlur = function () {
                        if (typeof originalOnBlur_1 === 'function') {
                            originalOnBlur_1();
                        }
                        // tslint:disable:no-any
                        _this.props.updateValue(id, 'isIncomplete', false);
                    };
                }
            }
            return __assign({}, originalProps, rowProps);
        };
        _this.getPaginationProps = function () {
            return {
                anchor: _this.paginationRef
            };
        };
        _this.tableRef = createRef();
        _this.state = {
            columns: _this.updateColumns(props.columns || [], props),
            popoverState: { tablePopoverOpen: false }
        };
        return _this;
    }
    Table.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateTableDom);
        this.updateTableDom();
    };
    Table.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var prevData = prevProps.data || [];
        var thisData = (this.props.data || []);
        var prevPageSize = prevProps.pageSize;
        var thisPageSize = this.props.pageSize;
        if (prevData.length !== thisData.length || prevPageSize !== thisPageSize) {
            requestAnimationFrame(function () { return _this.updateTableDom(); });
        }
    };
    Table.prototype.shouldUpdateColumns = function (props) {
        return (props.selector !== this.props.selector ||
            props.selectedRows !== this.props.selectedRows ||
            props.data !== this.props.data ||
            props.selectAll !== this.props.selectAll ||
            props.select !== this.props.select ||
            props.showFooter !== this.props.showFooter);
    };
    Table.prototype.componentWillReceiveProps = function (props) {
        var newColumns = this.state.columns;
        if (this.shouldUpdateColumns(props)) {
            newColumns = this.updateColumns(props.columns || [], props);
        }
        this.setState({
            columns: newColumns
        });
    };
    Table.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateTableDom);
    };
    Table.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.showPagination, showPagination = _b === void 0 ? false : _b, pageSize = _a.pageSize, _c = _a.loading, loading = _c === void 0 ? !this.props.data : _c, className = _a.className, otherProps = __rest(_a, ["showPagination", "pageSize", "loading", "className"]);
        var classes = [mtrTable];
        if (className) {
            classes.push(className);
        }
        var data = (this.props.data || []);
        var popoverState = this.props.popoverState || this.state.popoverState;
        return (createElement(Fragment, null,
            createElement(ReactTable$1, __assign({}, otherProps, { ref: this.tableRef, className: classes.join(' '), noDataText: loading ? '' : undefined, columns: this.state.columns, loading: loading, showPagination: showPagination, data: data, resolveData: this.props.resolveData, getTrProps: this.getTrProps, TrComponent: RowComponent, getTdProps: this.getTdProps, getPaginationProps: this.getPaginationProps, rowsText: "rows", minRows: 1, defaultPageSize: pageSize || data.length, PaginationComponent: Pagination })),
            createElement("div", { ref: function (node) { return (_this.paginationRef = node); } }),
            createElement(Popover, { shouldClose: this.closePopover, open: popoverState.tablePopoverOpen, anchor: popoverState.tablePopoverAnchor, position: popoverState.tablePopoverPosition, origin: popoverState.tablePopoverOrigin }, popoverState.tablePopoverContent)));
    };
    Table.prototype.getRowClass = function (id, errors) {
        var className = mtrTableRow;
        if (this.props.selectedRows && this.props.selectedRows.has(id)) {
            className += " " + mtrTableSelectedRow;
        }
        if (errors) {
            className += " " + mtrTableRowInvalid;
        }
        return className;
    };
    Table.prototype.updateColumns = function (columns, props) {
        var selector = props.selector, selectedRows = props.selectedRows, showStatusColumn = props.showStatusColumn, data = props.data, selectAll = props.selectAll, select = props.select, showFooter = props.showFooter;
        var selectedRowCount = selectedRows ? selectedRows.size : 0;
        if (showStatusColumn) {
            var idx = columns.findIndex(function (col) { return col.id === STATUS_COLUMN_ID; });
            if (idx !== -1) {
                var originalStatusColumn = columns[idx];
                var originalCell_1 = originalStatusColumn.Cell;
                var statusColumn = __assign({}, originalStatusColumn, { 
                    // tslint:disable-next-line:no-any
                    Cell: function (cellData, column) {
                        var elem = typeof originalCell_1 === 'function'
                            ? originalCell_1(cellData, column)
                            : originalCell_1;
                        return (createElement(Fragment, null,
                            createElement(SvgComponent$6, { className: mtrTableRowInvalidWarning, width: 18, height: 18 }),
                            elem));
                    } });
                columns = columns.slice(0, idx).concat([
                    statusColumn
                ], columns.slice(idx + 1));
            }
            else {
                columns = [
                    {
                        Header: '',
                        width: 40,
                        Cell: function () {
                            return (createElement(Fragment, null,
                                createElement(SvgComponent$6, { className: mtrTableRowInvalidWarning, width: 18, height: 18 })));
                        },
                        id: STATUS_COLUMN_ID
                    }
                ].concat(columns);
            }
        }
        if (selector) {
            columns = [
                {
                    width: 50,
                    Header: function () { return (createElement(Checkbox, { name: "select-all", checked: Boolean(selectedRows &&
                            data &&
                            data.length &&
                            data.reduce(function (allSelected, _a) {
                                var id = _a.id;
                                return allSelected && selectedRows.has(id);
                            }, true)), onChange: selectAll })); },
                    Cell: function (_a) {
                        var id = _a.original.id;
                        return (createElement(Checkbox, { name: id, checked: Boolean(selectedRows && selectedRows.has(id)), onChange: select }));
                    },
                    id: 'selector',
                    sortable: false,
                    className: mtrTableCenterCellContent,
                    Footer: showFooter && (createElement(Fragment, null,
                        createElement(Checkbox, { name: 'selectedRows', checked: true, disabled: selectedRowCount > 0 }),
                        ' ',
                        selectedRowCount))
                }
            ].concat(columns);
        }
        return columns;
    };
    Table.prototype.updatePopoverState = function (state) {
        if (this.props.updatePopoverState) {
            this.props.updatePopoverState(state);
        }
        else {
            this.setState({ popoverState: state });
        }
    };
    return Table;
}(Component));
function getEmptyCellClass(value) {
    return value ? '' : mtrTableEmptyCell;
}
var RowComponent = /** @class */ (function (_super) {
    __extends(RowComponent, _super);
    function RowComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function () {
            setTimeout(function () {
                var node = _this.ref.current;
                var foundNode;
                if (node && !node.contains) {
                    foundNode = findDOMNode(node);
                }
                var onBlur = _this.props.onBlur;
                if (onBlur &&
                    node &&
                    ((node.contains && !node.contains(document.activeElement)) ||
                        (foundNode && !foundNode.contains(document.activeElement)))) {
                    onBlur();
                }
            });
        };
        _this.ref = createRef();
        return _this;
    }
    RowComponent.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, TrComponent = _a.TrComponent, elemProps = __rest(_a, ["className", "children", "TrComponent"]);
        var rowProps = {
            className: classnames('rt-tr', className),
            role: 'row',
            onBlur: this.handleBlur,
            ref: this.ref
        };
        return TrComponent ? (createElement(TrComponent, __assign({}, elemProps, rowProps), children)) : (createElement("div", __assign({}, rowProps), children));
    };
    return RowComponent;
}(Component));

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgComponent$7 = function (props) {
  return React__default.createElement("svg", _extends$7({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M38 26H26v12h-4V26H10v-4h12V10h4v12h12v4z"
  }));
};

var ADD_ITEM_ROW_ID = 'ADD_ITEM_ROW';
/**
 * Wraps a ReactTable component to provide an "add item" row. Exposes an `innerRef` property that
 * can be passed a ref to the underlying ReactTable component. Also adds an `addRowLabel` property
 * that if present indicates the "add row" label should be rendered and serves as its label.
 */
function enableAddItemRow(BaseTable) {
    return /** @class */ (function (_super) {
        __extends(AddItemRowTable, _super);
        function AddItemRowTable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getTrProps = function (_state, rowInfo) {
                // tslint:disable-next-line:no-any
                var rest = [];
                for (
                // tslint:disable-next-line:no-any
                var _i = 2; 
                // tslint:disable-next-line:no-any
                _i < arguments.length; 
                // tslint:disable-next-line:no-any
                _i++) {
                    // tslint:disable-next-line:no-any
                    rest[_i - 2] = arguments[_i];
                }
                var _a = _this.props, TrComponent = _a.TrComponent, _b = _a.getTrProps, originalGetTrProps = _b === void 0 ? ReactTableDefaults.getTrProps : _b, addRowLabel = _a.addRowLabel, addRow = _a.addRow;
                var _c = _this.props, _d = _c.columns, columns = _d === void 0 ? [] : _d, _e = _c.data, data = _e === void 0 ? [] : _e;
                data = _this.updateData(data, _this.props, columns);
                var original = rowInfo && rowInfo.original;
                var id = (original && original.id) || '';
                var props = __assign({}, ((originalGetTrProps && originalGetTrProps.apply(void 0, [_state,
                    rowInfo].concat(rest))) ||
                    {}), { AddItemRowTrComponent: TrComponent });
                if (id === ADD_ITEM_ROW_ID) {
                    props = __assign({}, props, { addRowLabel: addRowLabel,
                        addRow: addRow, className: mtrTableAddUnitRow });
                }
                return props;
            };
            return _this;
        }
        AddItemRowTable.prototype.render = function () {
            var _a = this.props, data = _a.data, innerRef = _a.innerRef, pageSize = _a.pageSize, _b = _a.defaultSortMethod, defaultSortMethod = _b === void 0 ? ReactTableDefaults.defaultSortMethod : _b, showPagination = _a.showPagination;
            var _c = this.props.columns, columns = _c === void 0 ? [] : _c;
            columns = columns.map(function (column) {
                if (column.sortMethod) {
                    return __assign({}, column, { sortMethod: createAddItemRowSort(column.sortMethod.bind(column)) });
                }
                else {
                    return column;
                }
            });
            return (createElement(BaseTable, __assign({}, this.props, { ref: innerRef, TrComponent: RowComponent$1, getTrProps: this.getTrProps, data: data, resolveData: function (tableData) { return tableData.concat([createAddItem(columns)]); }, columns: columns, defaultSortMethod: createAddItemRowSort(defaultSortMethod), pageSize: showPagination
                    ? pageSize
                    : Math.max(Number(pageSize) || 0, data ? data.length + 1 : 1) })));
        };
        AddItemRowTable.prototype.updateData = function (data, props, columns) {
            var addRowLabel = props.addRowLabel;
            data = data || [];
            if (addRowLabel) {
                data = data.concat([createAddItem(columns)]);
            }
            return data;
        };
        return AddItemRowTable;
    }(Component));
}
function createAddItemRowSort(sort) {
    return function (a, b, desc) {
        if (typeof a === 'string' && a === ADD_ITEM_ROW_ID) {
            // The table handles descending order by reversing the list, so
            // everything but ADD_ITEM_ROW_ID will remain in the same order.
            return desc ? -1 : 1;
        }
        else if (typeof b === 'string' && b === ADD_ITEM_ROW_ID) {
            return desc ? 1 : -1;
        }
        else {
            return sort(a, b, desc);
        }
    };
}
function createAddItem(columns) {
    return columns.reduce(function (addItem, _a) {
        var accessor = _a.accessor, id = _a.id;
        if (typeof accessor === 'string') {
            addItem[accessor] = ADD_ITEM_ROW_ID;
        }
        else if (id) {
            addItem[id] = ADD_ITEM_ROW_ID;
        }
        return addItem;
    }, { id: ADD_ITEM_ROW_ID });
}
var RowComponent$1 = /** @class */ (function (_super) {
    __extends(RowComponent, _super);
    function RowComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = createRef();
        return _this;
    }
    RowComponent.prototype.render = function () {
        var _a = this.props, _b = _a.AddItemRowTrComponent, AddItemRowTrComponent = _b === void 0 ? ReactTableDefaults.TrComponent : _b, addRowLabel = _a.addRowLabel, addRow = _a.addRow, children = _a.children, className = _a.className, otherProps = __rest(_a, ["AddItemRowTrComponent", "addRowLabel", "addRow", "children", "className"]);
        if (addRowLabel) {
            var rowClassName = classnames(mtrTableAddUnitRow, className);
            return (createElement("div", __assign({ className: "rt-tr", onClick: addRow }, otherProps),
                createElement("div", { className: "rt-td " + rowClassName },
                    createElement(SvgComponent$7, { height: 24, width: 24 }),
                    " ",
                    createElement("span", null, addRowLabel))));
        }
        else if (AddItemRowTrComponent) {
            return (createElement(AddItemRowTrComponent, __assign({ className: className }, otherProps), children));
        }
        return null;
    };
    return RowComponent;
}(Component));

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgComponent$8 = function (props) {
  return React__default.createElement("svg", _extends$8({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0V0z"
  }), React__default.createElement("path", {
    d: "M22 36c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zm-4-16c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0-12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm12 8c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
  }));
};

/**
 * Wraps a ReactTable component to provide drag and drop functionality. An this
 * exposes an `innerRef` property that can be passed a ref to the underlying
 * ReactTable component, as well as a `moveRow` property which is required to
 * update state after a row has been dragged. This will be called with the ID
 * of the dragged item as `from`, and the target as `to`. A `data-id` property
 * is expected to be passed to the row component, and this is done by default
 * by the `UnitTrackingTable` component.
 */
function enableDragAndDrop(BaseTable) {
    return /** @class */ (function (_super) {
        __extends(DragAndDropTable, _super);
        function DragAndDropTable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // tslint:disable-next-line:no-any
            _this.getTrProps = function (finalState, rowInfo) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                var _a = _this.props, TrComponent = _a.TrComponent, _b = _a.getTrProps, originalGetTrProps = _b === void 0 ? ReactTableDefaults.getTrProps : _b, moveRow = _a.moveRow, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
                var calledDragEnd = false;
                return __assign({}, ((originalGetTrProps && originalGetTrProps.apply(void 0, [finalState, rowInfo].concat(args))) ||
                    {}), { 'data-id': rowInfo.original.id, DndTrComponent: TrComponent, moveRow: moveRow,
                    onDragStart: function (id) {
                        calledDragEnd = false;
                        if (onDragStart) {
                            onDragStart(id);
                        }
                    },
                    onDragEnd: function (id) {
                        if (!calledDragEnd && onDragEnd) {
                            calledDragEnd = true;
                            onDragEnd(id);
                        }
                    } });
            };
            return _this;
        }
        DragAndDropTable.prototype.render = function () {
            var _a = this.props, innerRef = _a.innerRef, _b = _a.columns, columns = _b === void 0 ? [] : _b;
            return (createElement(BaseTable, __assign({}, this.props, { columns: [
                    {
                        width: 20,
                        Header: '',
                        Cell: createElement("div", null)
                    }
                ].concat(columns), ref: innerRef, TrComponent: DndRowComponent, getTrProps: this.getTrProps })));
        };
        return DragAndDropTable;
    }(Component));
}
var ItemTypes = {
    ROW: 'row'
};
var rowSource = {
    beginDrag: function (props) {
        var id = props['data-id'];
        if (props.onDragStart) {
            props.onDragStart(id);
        }
        return { id: id };
    },
    endDrag: function (props) {
        var id = props['data-id'];
        if (props.onDragEnd) {
            props.onDragEnd(id);
        }
    }
};
var rowTarget = {
    drop: function (props, monitor) {
        var draggedId = monitor.getItem().id;
        var overId = props["data-id"];
        if (draggedId && overId && draggedId !== overId) {
            if (props.onDragEnd) {
                props.onDragEnd(draggedId);
            }
            props.moveRow(draggedId, overId);
        }
    }
};
var DndRow = /** @class */ (function (_super) {
    __extends(DndRow, _super);
    function DndRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DndRow.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.DndTrComponent, DndTrComponent = _c === void 0 ? ReactTableDefaults.TrComponent : _c, children = _b.children, connectDropTarget = _b.connectDropTarget, connectDragPreview = _b.connectDragPreview, isDragging = _b.isDragging, connectDragSource = _b.connectDragSource, _moveRow = _b.moveRow, _onDragEnd = _b.onDragEnd, _onDragStart = _b.onDragStart, otherProps = __rest(_b, ["DndTrComponent", "children", "connectDropTarget", "connectDragPreview", "isDragging", "connectDragSource", "moveRow", "onDragEnd", "onDragStart"]);
        if (!DndTrComponent) {
            return null;
        }
        if (this.props['data-id']) {
            return (connectDropTarget &&
                connectDragPreview &&
                connectDragSource &&
                connectDropTarget(connectDragPreview(createElement("div", { className: classnames(mtrTableDndPreview, (_a = {},
                        _a[mtrTableDndPreviewDragging] = isDragging,
                        _a)) },
                    createElement(DndTrComponent, __assign({}, otherProps),
                        children,
                        connectDragSource(createElement("div", { className: mtrTableDndSource },
                            createElement(SvgComponent$8, { className: mtrTableDndSourceIcon }))))))));
        }
        return createElement(DndTrComponent, __assign({}, otherProps), children);
    };
    return DndRow;
}(Component));
var DndRowComponent = /** @class */ (function (_super) {
    __extends(DndRowComponent, _super);
    function DndRowComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DndRowComponent = __decorate([
        DragSource(ItemTypes.ROW, rowSource, function (connect, monitor) { return ({
            connectDragSource: connect.dragSource(),
            connectDragPreview: connect.dragPreview(),
            isDragging: monitor.isDragging()
        }); }),
        DropTarget(ItemTypes.ROW, rowTarget, function (connect) { return ({
            connectDropTarget: connect.dropTarget()
        }); })
    ], DndRowComponent);
    return DndRowComponent;
}(DndRow));

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgComponent$9 = function (props) {
  return React__default.createElement("svg", _extends$9({
    viewBox: "0 0 48 48"
  }, props), React__default.createElement("path", {
    d: "M12 20c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm24 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-12 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
  }));
};

/**
 * Wraps a ReactTable component to provide an "add item" row. Exposes an `innerRef` property that
 * can be passed a ref to the underlying ReactTable component. Also adds an `addRowLabel` property
 * that if present indicates the "add row" label should be rendered and serves as its label.
 */
function enableRowActions(BaseTable) {
    return /** @class */ (function (_super) {
        __extends(AddItemRowTable, _super);
        function AddItemRowTable(props) {
            var _this = _super.call(this, props) || this;
            // tslint:disable-next-line:no-any
            _this.getTrProps = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var originalGetTrProps = _this.props.getTrProps;
                return __assign({}, (originalGetTrProps
                    ? originalGetTrProps.apply(void 0, args) : undefined), { className: mtrTableRowAction });
            };
            _this.updatePopoverState = function (state) {
                _this.setState(state);
            };
            _this.toggleActionPopover = function (id, actionPopoverProps, element) {
                var _a = _this.state, tablePopoverRowId = _a.tablePopoverRowId, tablePopoverAnchor = _a.tablePopoverAnchor;
                var shouldBeOpen = tablePopoverRowId !== id || element !== tablePopoverAnchor;
                var PopoverContent = _this.props
                    .ActionPopoverContent;
                if (shouldBeOpen) {
                    _this.setState({
                        tablePopoverRowId: id,
                        tablePopoverOpen: true,
                        tablePopoverAnchor: element,
                        tablePopoverPosition: {
                            horizontal: 'left',
                            vertical: 'bottom'
                        },
                        tablePopoverOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        },
                        tablePopoverContent: (createElement(PopoverContent, __assign({ actionComplete: _this.closePopover }, actionPopoverProps)))
                    });
                }
                else {
                    _this.closePopover();
                }
            };
            _this.closePopover = function () {
                _this.setState({
                    tablePopoverOpen: false,
                    tablePopoverAnchor: undefined,
                    tablePopoverRowId: undefined
                });
            };
            _this.wrappedColumns = props.columns;
            _this.columns = _this.updateColumns(props.columns);
            _this.state = {
                tablePopoverOpen: false
            };
            return _this;
        }
        AddItemRowTable.prototype.render = function () {
            var columns = this.props.columns;
            if (this.wrappedColumns !== columns) {
                this.wrappedColumns = columns;
                this.columns = this.updateColumns(this.wrappedColumns);
            }
            return (createElement(BaseTable, __assign({}, this.props, { columns: this.columns, popoverState: this.state, updatePopoverState: this.updatePopoverState, getTrProps: this.getTrProps })));
        };
        AddItemRowTable.prototype.updateColumns = function (columns) {
            var _this = this;
            if (columns) {
                // Check to see if there's already a status column. If there is, modify
                // it to show the row action button.
                var idx = columns.findIndex(function (col) { return col.id === STATUS_COLUMN_ID; });
                if (idx !== -1) {
                    var originalStatusColumn = columns[idx];
                    var originalCell_1 = originalStatusColumn.Cell;
                    var statusColumn = __assign({}, originalStatusColumn, { 
                        // tslint:disable-next-line:no-any
                        Cell: function (data, column) {
                            var original = data.original;
                            var id = original.id;
                            var elem = typeof originalCell_1 === 'function'
                                ? originalCell_1(data, column)
                                : originalCell_1;
                            return (createElement(Fragment, null,
                                elem,
                                createElement(Button, { buttonType: "secondary", size: "xs", className: mtrTableRowActionButton, label: createElement(SvgComponent$9, { width: 24, height: 24 }), onClick: function (event) {
                                        event.stopPropagation();
                                        var currentTarget = event.currentTarget;
                                        setTimeout(function () {
                                            _this.toggleActionPopover(id, _this.props.getActionPopoverContentProps &&
                                                _this.props.getActionPopoverContentProps(original), currentTarget);
                                        });
                                    } })));
                        } });
                    return columns.slice(0, idx).concat([
                        statusColumn
                    ], columns.slice(idx + 1));
                }
            }
            // There wasn't an existing status column, so add one at the beginning
            // of the columns list
            return [
                {
                    Header: '',
                    width: 40,
                    Cell: function (_a) {
                        var original = _a.original;
                        var id = original.id;
                        return (createElement(Button, { buttonType: "secondary", size: "xs", className: mtrTableRowActionButton, label: createElement(SvgComponent$9, { width: 24, height: 24 }), onClick: function (event) {
                                event.stopPropagation();
                                var currentTarget = event.currentTarget;
                                setTimeout(function () {
                                    _this.toggleActionPopover(id, _this.props.getActionPopoverContentProps &&
                                        _this.props.getActionPopoverContentProps(original), currentTarget);
                                });
                            } }));
                    },
                    id: STATUS_COLUMN_ID
                }
            ].concat((columns || []));
        };
        return AddItemRowTable;
    }(Component));
}

// tslint:disable:no-any;
var _DayPickerInput = require('react-day-picker/DayPickerInput').default;
var DayPickerInputConst = _DayPickerInput;

var select = "select";

var moment = require('react-day-picker/moment');
/**
 * DatePicker is a text input with an associated popup calendar for selecting a
 * date.
 *
 * Eventually this component should be moved to @built/design-system.
 */
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.createCaptionElement = function (props) {
            return (createElement(YearMonthForm, { date: props.date, fromYear: _this.state.fromYear, toYear: _this.state.toYear, localeUtils: props.localeUtils, onChange: _this.handleYearMonthChange }));
        };
        _this.handleDayClick = function () {
            _this.ref.current.hideDayPicker();
        };
        _this.handleClick = function () {
            if (!_this.ref.current) {
                return;
            }
            var node = findDOMNode(_this.ref.current);
            if (!node.contains(document.activeElement)) {
                _this.ref.current.hideDayPicker();
            }
        };
        _this.handleYearMonthChange = function (month) {
            _this.setState({ month: month });
        };
        _this.ref = createRef();
        var now = new Date();
        _this.state = {
            month: new Date(),
            fromYear: now.getFullYear() - 5,
            toYear: now.getFullYear() + 5
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        // The click event listener is needed because of focus handling issues in
        // IE 11.
        window.addEventListener('click', this.handleClick);
    };
    DatePicker.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.handleClick);
    };
    DatePicker.prototype.render = function () {
        // The `keepFocus` option is set to false so the DayPicker won't be
        // summarily closed in IE11. (The DayPicker has to force the picker input
        // to be focused due to some other IE-related issues, but that causes
        // problems with the month and year selectors we're adding here.)
        //
        // To close the DayPicker, a window-level click handler is used. When a
        // click is detected, the handler checks to see if the DayPicker is the
        // active element. If not, the DayPicker is closed.
        var _a = this.props.component, component = _a === void 0 ? DateInput : _a;
        return (createElement(DayPickerInputConst, __assign({ formatDate: formatDate, parseDate: parseDate, placeholder: "mm/dd/yyyy", format: "MM/DD/YYYY", keepFocus: false }, this.props, { component: component, ref: this.ref, dayPickerProps: {
                month: this.state.month,
                onDayClick: this.handleDayClick,
                captionElement: this.createCaptionElement
            } })));
    };
    return DatePicker;
}(Component));
function YearMonthForm(props) {
    var months = props.localeUtils.getMonths('');
    var years = [];
    for (var i = props.fromYear; i <= props.toYear; i++) {
        years.push(i);
    }
    var value = {
        month: String(props.date.getMonth()),
        year: String(props.date.getFullYear())
    };
    var handleChange = function (event) {
        var currentTarget = event.currentTarget;
        var name = currentTarget.getAttribute('name');
        value[name] = currentTarget.value;
        props.onChange(new Date(Number(value.year), Number(value.month)));
    };
    return (createElement("div", { className: "DayPicker-Caption" },
        createElement(Form.Select, { name: "month", onChange: handleChange, value: value.month, className: select, size: "sm" }, months.map(function (month, i) { return (createElement(Form.Select.Option, { key: month, value: String(i), label: month })); })),
        createElement(Form.Select, { name: "year", onChange: handleChange, value: value.year, className: select, size: "sm" }, years.map(function (year) {
            var yearStr = String(year);
            return (createElement(Form.Select.Option, { key: yearStr, value: yearStr, label: yearStr }));
        }))));
}
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = createRef();
        return _this;
    }
    DateInput.prototype.render = function () {
        return (createElement("input", __assign({ ref: this.ref, className: mtrFormControl }, this.props)));
    };
    DateInput.prototype.focus = function () {
        if (this.ref.current) {
            this.ref.current.focus();
        }
    };
    return DateInput;
}(Component));
function formatDate(date, format, locale) {
    return moment.formatDate(date, format, locale);
}
function parseDate(date, format, locale) {
    return moment.parseDate(date, format, locale);
}

// currencyColumn -------------------------------------------------------------
function currencyColumn(props) {
    var updateValue = props.updateValue, placeholder = props.placeholder, columnProps = __rest(props, ["updateValue", "placeholder"]);
    columnProps.className = classnames(updateValue && mtrTableInputColumn, props.className);
    var fieldClassName = classnames(mtrTableField, mtrTableFieldRight);
    if (updateValue) {
        var field_1 = (props.id || props.accessor);
        columnProps.Cell = function (_a) {
            var value = _a.value, id = _a.original.id;
            value =
                value == null
                    ? value
                    : formatCurrency(typeof value === 'number' ? value : Number(value) || 0);
            // Keep track of whether the input has been changed by the user. If it
            // hasn't been set by the user, any value it has was set programmatically
            // and shouldn't trigger an update.
            var changed = false;
            var handleChanged = function () {
                changed = true;
            };
            var handleBlur = function (event) {
                if (changed) {
                    var newValue = event.currentTarget.value;
                    if (newValue !== value) {
                        var cleanValue = newValue.replace(/[$,]/g, '');
                        var numericValue = Number(cleanValue);
                        updateValue(id, field_1, 
                        // tslint:disable-next-line:no-any
                        (cleanValue && !isNaN(numericValue) ? numericValue : null));
                    }
                    changed = false;
                }
            };
            var handleKeyPress = function (event) {
                if (event.key === 'Enter') {
                    handleBlur(event);
                }
            };
            return (createElement(Input, { name: "", className: fieldClassName, onChange: handleChanged, onBlur: handleBlur, onKeyPress: handleKeyPress, placeholder: placeholder == null ? '0.00' : placeholder, value: value }));
        };
    }
    else {
        columnProps.Cell = function (_a) {
            var value = _a.value;
            var _b;
            var val = value == null
                ? props.placeholder
                : formatCurrency(typeof value === 'number' ? value : Number(value) || 0);
            var className = classnames(fieldClassName, (_b = {},
                _b[mtrTableFieldEmpty] = value == null,
                _b));
            return createElement("div", { className: className },
                " ",
                val,
                " ");
        };
    }
    if (!columnProps.footerClassName) {
        columnProps.footerClassName = classnames(mtrTableField, mtrTableFieldRight);
    }
    return columnProps;
}
// dateColumn -----------------------------------------------------------------
function dateColumn(props) {
    var updateValue = props.updateValue, columnProps = __rest(props, ["updateValue"]);
    columnProps.className = classnames(updateValue && mtrTableInputColumn, mtrTableDateCell, props.className);
    if (updateValue) {
        var field_2 = (props.id || props.accessor);
        columnProps.Cell = function (_a) {
            var value = _a.value, id = _a.original.id;
            return (createElement(DatePicker, { value: value instanceof Date ? value : undefined, placeholder: props.placeholder, onDayChange: function (day) {
                    // tslint:disable-next-line:no-any
                    updateValue(id, field_2, day || null);
                } }));
        };
    }
    else {
        columnProps.Cell = function (_a) {
            var value = _a.value;
            var _b;
            var val = value == null
                ? props.placeholder
                : typeof value === 'string'
                    ? value
                    : value.toLocaleDateString();
            var className = classnames(mtrTableField, (_b = {},
                _b[mtrTableFieldEmpty] = value == null,
                _b));
            return createElement("div", { className: className }, val);
        };
    }
    return columnProps;
}
// percentColumn --------------------------------------------------------------
function percentColumn(props) {
    var updateValue = props.updateValue, placeholder = props.placeholder, columnProps = __rest(props, ["updateValue", "placeholder"]);
    var field = (props.id || props.accessor);
    columnProps.className = classnames(updateValue && mtrTableInputColumn, props.className);
    var fieldClassName = classnames(mtrTableField, mtrTableFieldRight);
    if (updateValue) {
        columnProps.Cell = function (_a) {
            var value = _a.value, id = _a.original.id;
            value = value == null ? value : formatPercent(value);
            // Keep track of whether the input has been changed by the user. If it
            // hasn't been set by the user, any value it has was set programmatically
            // and shouldn't trigger an update.
            var changed = false;
            var handleChanged = function () {
                changed = true;
            };
            var handleBlur = function (event) {
                if (changed) {
                    var newValue = event.currentTarget.value;
                    if (newValue !== value) {
                        var cleanValue = newValue.replace(/[%]/g, '');
                        var numericValue = Number(cleanValue);
                        updateValue(id, field, 
                        // tslint:disable-next-line:no-any
                        (cleanValue && !isNaN(numericValue) ? numericValue : null));
                    }
                    changed = false;
                }
            };
            var handleKeyPress = function (event) {
                if (event.key === 'Enter') {
                    handleBlur(event);
                }
            };
            return (createElement(Input, { name: "", className: fieldClassName, onChange: handleChanged, onBlur: handleBlur, onKeyPress: handleKeyPress, placeholder: placeholder == null ? '0%' : placeholder, value: value }));
        };
    }
    else {
        columnProps.Cell = function (_a) {
            var value = _a.value;
            var _b;
            var val = value == null ? props.placeholder : formatPercent(value);
            var className = classnames(fieldClassName, (_b = {},
                _b[mtrTableFieldEmpty] = value == null,
                _b));
            return createElement("div", { className: className }, val);
        };
    }
    if (!columnProps.footerClassName) {
        columnProps.footerClassName = classnames(mtrTableField, mtrTableFieldRight);
    }
    return columnProps;
}
// textColumn -----------------------------------------------------------------
function textColumn(props) {
    var updateValue = props.updateValue, placeholder = props.placeholder, columnProps = __rest(props, ["updateValue", "placeholder"]);
    columnProps.className = classnames(updateValue && mtrTableInputColumn, props.className);
    if (updateValue) {
        var field_3 = (props.id || props.accessor);
        columnProps.Cell = function (_a) {
            var value = _a.value, id = _a.original.id;
            return (createElement(Input, { className: mtrTableField, name: "", onBlur: function (event) {
                    var newValue = event.currentTarget.value;
                    if (newValue !== value) {
                        // tslint:disable-next-line:no-any
                        updateValue(id, field_3, newValue);
                    }
                }, placeholder: placeholder, value: value }));
        };
    }
    else {
        columnProps.Cell = function (_a) {
            var value = _a.value;
            var _b;
            var className = classnames(mtrTableField, (_b = {},
                _b[mtrTableFieldEmpty] = value == null,
                _b));
            var val = value == null ? placeholder : value;
            return createElement("div", { className: className }, val);
        };
    }
    return columnProps;
}

export { Accordion, Avatar, Badge, Banner, Button, Checkbox, ContentWell, Form, Heading, Input, LayoutGrid, Menu, Loader, Modal, Password, Popover, Radio, Select, SideNav, Slider$1 as Slider, Tabs, Table, DatePicker, AccordionContent, AccordionTitle, Outline, FormGroup, FormOptions, numColumns, SideNavItem, enableAddItemRow, enableDragAndDrop, enableRowActions as enableRowAction, Pagination, STATUS_COLUMN_ID, ReactTable$1 as ReactTable, getEmptyCellClass, ADD_ITEM_ROW_ID, ItemTypes, rowSource, rowTarget, DndRow, currencyColumn, dateColumn, percentColumn, textColumn, DateInput };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@built/design-system/index.js
// module id = 11
// module chunks = 0